<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-stepper v-model="e1">
            <v-stepper-header >
                <v-stepper-step step="1">Fase 1</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2">Fase 2</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3">Fase 3</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="4">Fase 4</v-stepper-step>
            </v-stepper-header>
        </v-stepper>
        <v-form ref="form" v-model="valid" lazy-validation>

            <v-expansion-panel>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>Datos Básicos</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="codigo"
                                    label="Cédula/RUC"
                                    id="code"
                                    :rules="codeRules"
                                    :counter="13"
                                    disabled
                                    required
                                    v-model="$store.state.patient.identification"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="firstName"
                                    label="Primer Nombre"
                                    id="firstName"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                    v-model="$store.state.patient.firstName"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="secondName"
                                    label="Segundo Nombre"
                                    id="secondName"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                    v-model="$store.state.patient.secondName"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="firstLastName"
                                    label="Primer Apellido"
                                    id="firstLastName"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                    v-model="$store.state.patient.firstLastName"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="secondLastName"
                                    label="Segundo Apellido"
                                    id="secondLastName"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                    v-model="$store.state.patient.secondLastName"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>Dirección</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm7 offset-sm1>
                            <v-text-field
                                    name="direccion"
                                    label="Dirección"
                                    id="direccion"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                    v-model="$store.state.patient.address"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="addressDetail1"
                                    label="Barrio"
                                    id="addressDetail1"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 100) || 'El número de caracteres debe ser menor a 100']"
                                    v-model="$store.state.patient.addressDetail1"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="addressDetail2"
                                    label="Parroquia"
                                    id="addressDetail2"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 100) || 'El número de caracteres debe ser menor a 100']"
                                    v-model="$store.state.patient.addressDetail2"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="addressDetail3"
                                    label="Cantón"
                                    id="addressDetail3"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 100) || 'El número de caracteres debe ser menor a 100']"
                                    v-model="$store.state.patient.addressDetail3"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="this.itemsState"
                                    v-model="$store.state.patient.state"
                                    label="Provincia"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    return-object
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="this.itemsZone"
                                    v-model="$store.state.patient.zone"
                                    label="Zona"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    return-object
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="telefono"
                                    label="Teléfono"
                                    id="telefono"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                                    v-model="$store.state.patient.phone"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>Cultural/Nacionalidad</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-menu
                                    ref="menu"
                                    :close-on-content-click="false"
                                    v-model="menu"
                                    :nudge-right="40"
                                    :return-value.sync="date"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px">
                                <v-text-field
                                        slot="activator"
                                        v-model="$store.state.patient.birthday"
                                        label="Fecha de nacimiento"
                                        prepend-icon="event"
                                        readonly
                                ></v-text-field>
                                <v-date-picker v-model="$store.state.patient.birthday"
                                               @input="$refs.menu.save($store.state.patient.birthday)"></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="birthdayPlace"
                                    label="Lugar de nacimiento"
                                    id="birthdayPlace"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                    v-model="$store.state.patient.birthdayPlace"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="nationality"
                                    label="Nacionalidad"
                                    id="nationality"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                    v-model="$store.state.patient.nationality"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="this.itemsCultural"
                                    v-model="$store.state.patient.culturalGroup"
                                    label="Grupo Cultural"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    return-object
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="this.itemsGender"
                                    v-model="$store.state.patient.gender"
                                    label="Sexo"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    return-object
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="this.itemsCivil"
                                    v-model="$store.state.patient.civilStatus"
                                    label="Estado Civil"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    return-object
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>Trabajo</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="profession"
                                    label="Profesión"
                                    id="profession"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                    v-model="$store.state.patient.profession"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="ocupacion"
                                    label="Ocupación"
                                    id="ocupacion"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 250) || 'El número de caracteres debe ser menor a 250']"
                                    v-model="$store.state.patient.ocupacion"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-menu
                                    ref="menu2"
                                    :close-on-content-click="false"
                                    v-model="menu2"
                                    :nudge-right="40"
                                    :return-value.sync="date"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px">
                                <v-text-field
                                        slot="activator"
                                        v-model="$store.state.patient.admitionDate"
                                        label="Fecha de Admisión"
                                        prepend-icon="event"
                                        readonly
                                ></v-text-field>
                                <v-date-picker v-model="$store.state.patient.admitionDate"
                                               @input="$refs.menu2.save($store.state.patient.admitionDate)"></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="$store.state.companies"
                                    v-model="$store.state.patient.company"
                                    label="Empresa donde Trabaja"
                                    item-text="name"
                                    @change="changeCompany"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    return-object
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="itemsJobCompany"
                                    v-model="$store.state.patient.jobCompany"
                                    label="Puesto de Trabajo"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    item-value="name"
                                    item-text="name"
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="itemsAgencyCompany"
                                    v-model="$store.state.patient.agencyCompany"
                                    label="Sucursal"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    item-value="name"
                                    item-text="name"
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="costCenter"
                                    label="Centro de costos"
                                    id="costCenter"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                                    v-model="$store.state.patient.costCenter"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>Emergencia</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="emergencyCallName"
                                    label="En caso de emergencia llamar a"
                                    id="emergencyCallName"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                                    v-model="$store.state.patient.emergencyCallName"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="emergencyRelationship"
                                    label="Parentesco"
                                    id="emergencyRelationship"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                                    v-model="$store.state.patient.emergencyRelationship"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="direccionParentesco"
                                    label="Dirección Parentesco"
                                    id="direccionParentesco"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                                    v-model="$store.state.patient.emergencyAddress"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-text-field
                                    name="telefonoEmergencia"
                                    label="Teléfono"
                                    id="telefonoEmergencia"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                                    v-model="$store.state.patient.emergencyPhone"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>Otros</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="this.itemsReligion"
                                    v-model="$store.state.patient.religion"
                                    label="Religión"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    return-object
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <!--                <v-layout>-->
                    <!--                    <v-flex xs12 sm4 offset-sm1>-->
                    <!--                        <v-select-->
                    <!--                                :items="this.itemsLaterality"-->
                    <!--                                v-model="$store.state.patient.laterality"-->
                    <!--                                label="Lateralidad"-->
                    <!--                                :rules="[v => !!v || 'Campo requerido']"-->
                    <!--                                return-object-->
                    <!--                                persistent-hint-->
                    <!--                                required-->
                    <!--                        >-->
                    <!--                        </v-select>-->
                    <!--                    </v-flex>-->
                    <!--                </v-layout>-->
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="this.itemsSexualOrientation"
                                    v-model="$store.state.patient.sexualOrientation"
                                    label="Orientación Sexual"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    return-object
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <!--                <v-layout>-->
                    <!--                    <v-flex xs12 sm4 offset-sm1>-->
                    <!--                        <v-select-->
                    <!--                                :items="this.itemsDecision"-->
                    <!--                                v-model="$store.state.patient.disability"-->
                    <!--                                label="Discapacidad"-->
                    <!--                                :rules="[v => !!v || 'Campo requerido']"-->
                    <!--                                return-object-->
                    <!--                                persistent-hint-->
                    <!--                                required-->
                    <!--                        >-->
                    <!--                        </v-select>-->
                    <!--                    </v-flex>-->
                    <!--                </v-layout>-->
                    <!--                <v-layout>-->
                    <!--                    <v-flex xs12 sm4 offset-sm1>-->
                    <!--                        <v-text-field-->
                    <!--                                name="descripcion"-->
                    <!--                                label="Descripción"-->
                    <!--                                id="direccion"-->
                    <!--                                :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"-->
                    <!--                                v-model="$store.state.patient.disabilityDescription"-->
                    <!--                                required-->
                    <!--                        ></v-text-field>-->
                    <!--                    </v-flex>-->
                    <!--                </v-layout>-->

                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="this.itemsBlood"
                                    v-model="$store.state.patient.bloodType"
                                    label="Tipo de sangre"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    return-object
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-select
                                    :items="this.itemsStudies"
                                    v-model="$store.state.patient.studies"
                                    label="Escolaridad"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    return-object
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-textarea
                                    name="observaciones"
                                    label="Observaciones"
                                    id="observaciones"
                                    v-model="$store.state.patient.observation"
                            ></v-textarea>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-switch
                                    label="Inactivo / Activo"
                                    v-model="$store.state.patient.status"
                            ></v-switch>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-select
                                    :items="this.atencionPrioritariaOpciones"
                                    v-model="$store.state.patient.emergencyRelationshipPhone.ap"
                                    label="Atención prioritaria"
                                    :rules="[v => !!v || 'Campo requerido']"
                                    return-object
                                    persistent-hint
                                    required
                            >
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-menu
                                    ref="menu3"
                                    :close-on-content-click="false"
                                    v-model="menu3"
                                    :nudge-right="40"
                                    :return-value.sync="date"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px">
                                <v-text-field
                                        slot="activator"
                                        v-model="$store.state.patient.emergencyRelationshipPhone.it.fec"
                                        label="Fecha de ingreso al trabajo"
                                        prepend-icon="event"
                                        readonly
                                        :clearable="true"                                                                                                     
                                ></v-text-field>
                                <v-date-picker v-model="$store.state.patient.emergencyRelationshipPhone.it.fec"
                                               @input="$refs.menu3.save($store.state.patient.emergencyRelationshipPhone.it.fec)"></v-date-picker>
                            </v-menu>
                            <v-switch
                                    label="No conoce"
                                    v-model="$store.state.patient.emergencyRelationshipPhone.it.noc"
                                    :disabled="disableNoconoceFIT"
                            ></v-switch>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-menu
                                    ref="menu4"
                                    :close-on-content-click="false"
                                    v-model="menu4"
                                    :nudge-right="40"
                                    :return-value.sync="date"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px">
                                <v-text-field
                                        slot="activator"
                                        v-model="$store.state.patient.emergencyRelationshipPhone.reint.fec"
                                        label="Fecha de reintegro"
                                        prepend-icon="event"
                                        :clearable="true"
                                ></v-text-field>
                                <v-date-picker v-model="$store.state.patient.emergencyRelationshipPhone.reint.fec"
                                               @input="$refs.menu4.save($store.state.patient.emergencyRelationshipPhone.reint.fec)"></v-date-picker>
                            </v-menu>
                            <v-switch
                                    label="No conoce"
                                    v-model="$store.state.patient.emergencyRelationshipPhone.reint.noc"
                                    :disabled="disableNoconoceFR"
                            ></v-switch>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>
                            <v-menu
                                    ref="menu5"
                                    :close-on-content-click="false"
                                    v-model="menu5"
                                    :nudge-right="40"
                                    :return-value.sync="date"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px">
                                <v-text-field
                                        slot="activator"
                                        v-model="$store.state.patient.emergencyRelationshipPhone.udl.fec"
                                        label="Fecha del último día laboral"
                                        prepend-icon="event"
                                        :clearable="true"
                                ></v-text-field>
                                <v-date-picker v-model="$store.state.patient.emergencyRelationshipPhone.udl.fec"
                                               @input="$refs.menu5.save($store.state.patient.emergencyRelationshipPhone.udl.fec)"></v-date-picker>
                            </v-menu>
                            <v-switch
                                    label="No conoce"
                                    v-model="$store.state.patient.emergencyRelationshipPhone.udl.noc"
                                    :disabled="disableNoconoceFUL"
                            ></v-switch>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm4 offset-sm1>                            
                            <v-switch
                                    label="¿Autoriza recibir transfusiones? No / Si"
                                    v-model="$store.state.patient.emergencyRelationshipPhone.at"
                            ></v-switch>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-layout>
                <v-flex>
                    <div class="text-xs-center">
                        <v-btn color="primary" @click="print" dark>Imprimir</v-btn>
                        <v-btn :disabled="!valid"
                               @click="saveData" dark color="primary">Actualizar Datos
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-form>
        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique la información requerida para continuar.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>

    import Patient from "../../../model/Patient";
    import AnexoSaludTrabajo from '../anexoSaludTrabajo/AnexoSaludTrabajo'
    import Carousel from "../monitoreo/Carousel";


    export default {
        components: {
            AnexoSaludTrabajo,
            Carousel,

        },
        data() {
            return {
                dialog: false,
                search: '',
                valid: false,
                codeRules: [
                    v => !!v || 'El código es requerido',
                    v => (v && v.length <= 13 && v.length > 9) || 'El código debe tener 10 o 13 caracteres'
                ],
                requiredField: [v => !!v || 'Es requerido'],
                e1: 1,
                dialogError: false,
                dialogPass: false,
                dialogSuccess: false,
                dialogRiesgoSocial: false,
                dialogRiesgoFamiliar: false,
                date: "",
                headers: [
                    {text: 'Cédula/RUC', value: 'identification'},
                    {text: 'Nombre', value: 'firstName'},
                    {text: 'Apellido', value: 'firstLastName'},
                    {text: 'Empresa', value: 'company.name'},
                    {text: 'Acciones en Pacientes           ', value: 'editar'},
                    {text: 'Hojas de Ruta', value: 'editar'}
                ],
                editedIndex: -1,
                patient: new Patient(),
                itemsAplica: ['Aplica', 'No Aplica'],
                itemsDecision: ['SI', 'NO'],
                itemsState: ['Azuay', 'Bolívar', 'Cañar', 'Carchi', 'Chimborazo', 'Cotopaxi', 'El Oro', 'Esmeraldas', 'Galápagos', 'Guayas', 'Imbabura', 'Loja', 'Los Ríos', 'Manabí', 'Morona Santiago', 'Napo', 'Orellana', 'Pastaza', 'Pichincha', 'Santa Elena', 'Santo Domingo de los Tsáchilas', 'Sucumbíos', 'Tungurahua', 'Zamora Chinchipe'],
                itemsZone: ['U', 'R'],
                itemsCultural: ['MESTIZO', 'AFROECUATORIANO', 'INDIGENA', 'BLANCO', 'NEGRO', 'OTRO'],
                itemsGender: ['M', 'F'],
                itemsCivil: ['SOL', 'CAS', 'DIV', 'VIU', 'U-L'],
                itemsBlood: ['O RH +', 'O RH -', 'A RH +', 'A RH -', 'B RH +', 'B RH -', 'AB RH +', 'AB RH -', 'NO CONOCE'],
                itemsReligion: ['CATÓLICA', 'EVANGÉLICA', 'TESTIGO JEHOVÁ', 'MORMONA', 'OTRA', 'NINGUNA'],
                itemsLaterality: ['DERECHO', 'IZQUIERDO', 'AMBIDIESTRO'],
                itemsSexualOrientation: ['LESBIANA', 'GAY', 'BISEXUAL', 'HETEROSEXUAL', 'NO SABE', 'NO RESPONDE'],
                itemsCompany: [],
                itemsJobCompany: [],
                itemsAgencyCompany: ['Sur', 'Centro', 'Norte'],
                itemsStudies: ['NO ESTUDIO', 'PRIMARIA INCOMPLETA', 'PRIMARIA COMPLETA', 'SECUNDARIA INCOMPLETA', 'SECUNDARIA COMPLETA', 'SUPERIOR INCOMPLETA', 'SUPERIOR COMPLETA', 'CARRERA TÉCNICA', 'CUARTO NIVEL'],
                agencies: [],
                workPlaces: [],
                disabledTab: true,
                active: 0,
                patients: [],
                menu: false,
                menu2: false,
                menu3: false,
                menu4: false,
                menu5: false,
                atencionPrioritariaOpciones: ['No aplica', 'Embarazada', 'Persona con discapacidad', 'E. Catastrófica', 'Lactancia', 'Adulto mayor'],
                disableFit: false                
            };
        }, methods: {
            saveData() {                
                if (this.valid) {
                    this.dialog = false;
                    // Crear copia del paciente para enviar al backend
                    let patientToSend = JSON.parse(JSON.stringify(this.$store.state.patient))
                    // Convertir emergencyRelationshipPhone a string solo en la copia
                    patientToSend.emergencyRelationshipPhone = JSON.stringify(this.$store.state.patient.emergencyRelationshipPhone)
                    this.$store.dispatch('updatePatientNoRedirect', JSON.stringify(patientToSend)).then(response => {
                        this.dialogSuccess = true
                    }, error => {
                        this.$store.state.progress = false
                        this.$store.state.dialogError = true
                    })
                } else {
                    this.dialogError = true
                }
            },

            changeCompany() {
                this.itemsJobCompany = []
                this.itemsAgencyCompany = []
                this.$store.dispatch('getCompanyJobsByCompany', this.$store.state.patient.company.id).then(
                    response => {
                        for (let i = 0; i < this.$store.state.companyJobs.length; i++) {
                            this.itemsJobCompany.push(this.$store.state.companyJobs[i])
                        }
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                )
                this.$store.dispatch('getCompanyAgenciesByCompany', this.$store.state.company.id).then(
                    response => {
                        for (let i = 0; i < this.$store.state.companyAgencies.length; i++) {
                            this.itemsAgencyCompany.push(this.$store.state.companyAgencies[i])
                        }
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                )

            },
            print() {
                let nomProfesional = this.$store.state.patient.usuarioCreaActualiza;
                let formattedDate = this.getFormattedDate(new Date());
                let formattedHour = this.getFormattedHour(new Date());
                let examFormat = this.$store.state.patientExamNumber
                const self = this;
                let docDefinition = {
                    header: {
                        style: 'tableHeader',
                        table: {
                            widths: [92, 92, 92, 92, 92],
                            body: [
                                [
                                    {
                                        fillColor: '#EBA394',
                                        text: 'ESTABLECIMIENTO'
                                    },
                                    {
                                        fillColor: '#EBA394',
                                        text: 'NOMBRES'
                                    },
                                    {
                                        fillColor: '#EBA394',
                                        text: 'APELLIDOS'
                                    },
                                    {
                                        fillColor: '#EBA394',
                                        text: 'SEXO (M-F)'
                                    },
                                    {
                                        fillColor: '#EBA394',
                                        text: 'No.HISTORIA CLINICA'
                                    },
                                ],
                                [this.$store.state.patient.company.name,
                                    this.$store.state.patient.firstName + " " + this.$store.state.patient.secondName,
                                    this.$store.state.patient.firstLastName + " " + this.$store.state.patient.secondLastName,
                                    this.$store.state.patient.gender,
                                    this.$store.state.patient.identification]
                            ]
                        }
                    },
                    footer: function (currentPage, pageCount, pageSize) {
                        // you can apply any logic and return any valid pdfmake element

                        return [
                            {
                                style: 'tableHeaderFooter',
                                table: {
                                    widths: [92, 72, 112, 112, 72],
                                    body: [
                                        [
                                            {
                                                fillColor: '#EBA394',
                                                text: 'FECHA Y HORA'
                                            },
                                            {
                                                fillColor: '#EBA394',
                                                text: 'FORMATO'
                                            },
                                            {
                                                fillColor: '#EBA394',
                                                text: 'NOM. PROF.'
                                            },
                                            {
                                                fillColor: '#EBA394',
                                                text: 'PROF. CIERRA HOJA'
                                            },
                                            {
                                                fillColor: '#EBA394',
                                                text: 'No. Hoja'
                                            },
                                        ],
                                        [
                                            formattedDate +" "+ formattedHour,
                                            examFormat,
                                            nomProfesional,
                                            self.$store.state.userRouteSheetStatus,
                                            currentPage.toString() + ' de ' + pageCount
                                        ]
                                    ]
                                }
                            }
                        ]
                    },
                    content: [
                        {
                            image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjcAAAI3CAYAAABnKHquAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAaN9JREFUeNrsvdt+G8l5t1utn88NL21JagNKEzuxEwv0eO/EApPMmoN1MOTBHAu8ApFXQPIKSF0BwWMfkDpYB5OxTciJPzuOY0FxnC+OLRHakNrNLMM38PXqQlcThUZ3o6vRDXQ3nmcGAjcg0P3W7l9vvfWWEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUFIsTAAgxM8uLlScp5rzqDqNouo831Bfe6ifn/2k7XzV1RqS/Pqx+rYl//neu5ctLAtB/OTCfN12nm1b1J1/nf/c+mb3X+LVR4+Oenh49U0+t+Xjw89fdbEsAOIGZpiHFxakgFlxHncsyxU1eoOwhhqJFdhgrIAW5fvZ2eCjBqP2d9++bFMCs0GrV8/smu0KlTu2K2B6dc0TMrbtfnf2ffKP6yph/VA+O2KHegaIG4DyDzTzcoC561T7FcsTM1aYmAkXNTEETZwGdjYIfectHp6y8M8XF6RHpu58edv1yoiKLYLFy8Cz7b4iBYGj03Eeh85jH6EDiBuAknF0Yb7hVPR7ojd7tvrixQoSM97Xo0WNZcVvUNbopiYFzgP5/O23LxiICsLPL16VInnFkSV3nGcpbCoDwsXWxUo8gRP0+5SEzn3n0WT5ChA3AAUXNc7T5pmXRhcsIcImyFtj+VrMqKWpGEJm4BV28EDUEzuO0DmkJPPFLy9drTmi5a4ravQlpgjxEiFyJihwJF0lcnYROYC4ASgQP70wX3cq9p7QAoL9wsbYW2ON8OIENKU0GpftDkaHCJ3p8qtL12qO6BgWNHaQmAkRLzG8OBMSOJ7I2XAETpPSBcQNQL5FjVwS2LPcQOEzqTJqGSrSWxMhavyCxkqpodnRA1LT+f0+S1fZ8+tL12Tw7z1d0OiyJFi06M8BAsXWBc/UBY6k5TzWHJHTocQBcQOQP2Ejg4UPrIFdT/GFTWBAsTVa1FgJGpVlJmjCft+WIkeKHUfosLyQEr+5fE0GAK84Br+rAoNDBUY8kTPKixMhcHqvm4jA6SqBg2cQEDcAORI2DeEuQ/Uq9NBSVExhE+StiStqkoic3gtsY1ET9DPpzbmPNyc5jy5fl6L4niM1ZF3qBwWHemVCBI76x3SZKuh9JixwJDIOZ4PaAIgbgCnzkwvzO04lXveLltHCJngZKshbEyZq4uS8SdrI7BAlY0cIHdvNpSNFTpOaEY/Hl6+vqKWn+rA9bZFY5AS8PlDABMThTFngyN1Ua9QMQNwATE/YyPiaRtrCxkTUxM95E72UZUdKmGCxY4eLnI5wl6x2WbIa5j8uX5eeGRmXtTkYSxNmTzORE8eLYyxwfDE4drYmQuAA4gZgSsJm3am8O8MixZUkcYRN1DJUxM6plvb1Q5+H5oviLGV+7x3q496nHfZVPJHTC0AWrjenM+t15j+v3JCiZr3nqbHtygjbDX09sMRkm3lxAt6jrcqnJ0ad1zzziaPbWs6cWu9rBA4A4gZKLWykt2bPChM2EYJllLdGEzYdyxUyvSMTvvX2RSvp9T66fF2KnIrlCp/bSgBV4wsb/8+ChU74gOwOVs7AuP2dty9nTuT8Toka0YupcQXDoP1sA3Ez7MmJEDkdtVT42PmInpj5/hjnjf34wnzdedOqTBiogp2rGQucbUfgbNHjAOIGIHthI4XBkeWKhVSFjfMKOfDLBGeZZwluu0sjNeXd6WW3FRGz8WChEy1yggdoW3pyZkLk/JcmaoQvc3CoiImIbQkVOX27t2zXmyeFTCvrJcF/Oj8nBbKMGborBg/ZTJNlR+C06HkAcQOQrbh5pDwg2tLS4JbvBMJGDvj70z7j6bHr4flICZ1amLAJ/j7YmxAxKJdW5Py3vvykeWri2VGPb7JHiZyO8wq5ffqhFDPvv5lefNMnrtDZFCoGLUXkPS2SzRgQNwDZCZsty+3AQwOIDYWNHJg28jjAP3a3Jsug17txhU6C3T1dW6Xi/+7bl4UfvH4/V5VxKUOiZtA6YbaL+HpQ5EiP3r4UM7U3z3O39T4jkXPoiJtVeiBA3ACkL2xkp31sidE7o6KCh9XrZDzNWlFO444jdKJETpj3QXtd77whR+BsFbV+/M9ctaEG9eA4FHt4R5pBMHHHtu37zteHX3/zvFMEezgiR9aTPZHechXLU4C4AchA3Bx5u4/8y1GGwmbXeWwX1VOhhE5DCZ1q2MDs39kz/LvA3CsyAHb7e29fNotijz/MVWWd2BER3q3An9vBglB7nfRqSTvsf+31s8ImR3REzpYSfePSccTNIj0RIG4A0hM28iDMIyFClpssvzdHEz6DwmbtuwUauGMIHc+bsxIkXvRB244vcORr5Qx943vvXuZ2UP/jXLWqRM1KpIiJ+LkdKHRsGRS8/1evn5WmnjgCRwrAAzG0VGfMGgdtAuIGID1xI8+MWokTZxN0pILzGumlWXaETSmPJ9C8OQNbnU22Lodk2JXHOmx8/11+vFxP5ha9HVCh3gg7RN5ExNxIL82h84Ptr7zudMpYR9Qy1dGYAgfvDSBuAFISNlWnkh4HiZew5ahZEjYBQkeKnLPMuyYJ6EKSz0n7bTsCZ3fa9/Z0blFue96xRuQIsmOKHi+Ts/O8++VXndLvBkpJ4KxywCYgbgDG5KcX5uXSw7pfvOj5bEJ3Rrm/l8KmNWt2089MSkHgSGTulrUfTGGpyhE1UszI4Ni6XrZhyibGspTcwr393qtOc9bqRQoCh51TgLgBSEHcHHsz9bjLUVqczYYjbHZn2X5tN3fO5qDIiS9w9Nep1zj2tLd/8O5kIp6O4/nFLeHb2j2q0woVN24s0f2br45n2vPgCBwZp3Qwxlt8ibw3gLgBSC5sep3wqOWoEGFz6AgbZpg+kWOfZUI2EDi2GBQ77rECa3/77qSV1fV25hdDtzInEDcySHh78fS4RU04Ezg9j2jCPyewGHLPOUwAOeZO1Gnc+jnbA79z42w49E+j9ua5TDq37HwpH62zJbyAxId+i1qWvwysqvPP0b9cXDj454sLlTSv0xE1lY7rrXkk3OMpNBFr+l8vn9Fy9fR4GWEziCNONoSbkDAJH2FBQNwAJGdFG1DPBtpIweP+YKMMGXezYMkROUtK5DjDfztI4Izabq+JH1k+x47AWUnj2p7NL8ot//J4jc0QsRL30UvSeOP0ePEGoiaKjXHaJUCeYVkKcslPB3ZJGS1HtR1hs4QF4/Gb3u4q291dNRhbE2d56uxr2z3KYu2HCWNxHGGz45TeuhWjg4rotOSW7u1rp093Kdl4fHJ+7iChWCFjMeQaPDeQV9Vd83sShr8fWo6SbGO9+HzjzfPmN968WLRcu3VDj7cQgctTepn0vDg/u7hQNxM1N2vO45GlCZtQj4zzzzlLeZGGH1LQLCJsjEnqvaljOkDcAJhT8y9Hhc3etYG38923L8nBkUjkvNhyDCkTtDWH7TsYfxO2LCjcHU1HDy8s7DiPkbE4z+dvbqllqFqYmBl4BIse6T1YXDh5unH19ClLkYZ8+PmrjnC9bqbcxnqAuAEw506giPENub7BFa/NGLz/5kX3/bcv1qyzoOPg+JvBsrACyqa3C+eodWGhFiJqqs5D5lrZ9IuVc4FiJvA/Z1C2ludPni47wqZD6Y3FfpLJB2aDPEPMDeSS1oX5PznVs2KJoJw2Q1mIva+/9B0CiVPj15euNWz3/KZKUPyNPzZn4Puz39vL9c9OW5qwaQg3y3BF74Cilrx89E4wnzt5skUJpccn5+dkfFvV5G8+/PwV4wfkFjw3kFcqQcGlIctR8utDhE26fPPti6bz1Fuq0uNvhAhengoorw1P2DiipuI8ZM6iPUuV7cDSkxBxdkZJb9ISwiYTjJem1IGcAIgbgDi0LszXwrZ++4OItdn9AyyXPt96+6LrPGTOILlU1RFCRC5Pqa+6Trkt3fnsZFcJG7mE8cjStvYHi5rQuBoZ6Lx65eTJsvPoUCqZQPsBxA1AtlhGXhsleVrYLVOR0/r2W7mryjqLawoK8vYCfH/47qSthM26EjZVS/i9bdbwEqPwb/UXu87z4uWTJwSKZ0jCbd3E3QDiBiC2tNEGzyCvzbDnwOo4Ay8z+gng2HnLeVqytOy2mvdm92/fnSz/3buTrlqGkktQO+FLUOGixssu7IiajUsnT1hunAymAqeCyQBxAxCfeoBHYFDmDP6gjckmx3fevmx/x02UuK2VgzwxvJczRS1DHTm/aggR7q0J2/7tfLErl7UcUdPC2hPlISaAsvAFTAB5xMBrI798jMUmz3ffvtz65aWrh7IIvu8IHiVsZFzNnr4bql+WVsgxD0IdAWH1zgS7+PKPLEFNByYJgLgBmIjIEcFeG5/IoVOensA5s/2z+ZtbQuWuCRM2geLGdescKmHDEtT0MLX9HUwGiBuAuILGGpY4wVuNzzwBDIhT5Nn8ovTSSG/NipGw6Xtrth1Rw7EJU0YGFX9yfg5DAOIGIDOBI0IOTbQCf47nZnrCpuo8HTgipSYMhI0rYHs73KS3piO/+/nFq733+MG7l5QnAIwFAcWQS2HT/3qk16aXiwWrTZ7O/GLdeXoklLCxYgub3r8bjqhZ7gubhS3hbhl/9IuLVxtYd3rFigkAcQMwAYFz9jMr3utgIsJGCpCjsyMyhD/3UKiwkV6ZJW8Z6l8uLtSchxRIm9rr93556eoOVs69uGF3FSBuAJIInOBkfhaiZooczy/uCTfGZrCMBrZ7By5FNZ0n6a3pLTv988WF3gGbli8ZnBJI6/966erery5dI5cKABhDzA3kUdS09dHSn404SvxAdjydW6w45aAFDltDZRG8XV90nX82Lr58IsWN+NnFhYo6Y2qlL4f6QcaaiG04T7V/u3RtmaVHADABzw3kka4lwsQMXptpCRvRW4byBMlw8j3/ad6WJ1QtsXypL2x650yJs3OmrMgDOJVX5/jXl66R6h8AEDdQdIZn8yJoEETpZM6TucWewHAETM0SA8kTQ8tM/bblPKSw0Xc/ddTp3qPOCtOXtaSn5+jfL1+rUxq5gl1tgLgBiC9rBjvNqOUntE3mwkYKCumxqYQJzP55UQPsXj55suw/F+qH7066f/fuRJ4yvjEi67RfxPYEzqPL1xuUSm5gqRAQNwBx+YEzAIoQv0BQACtkwx/nqlJIHPU8J5a+1GQFqMuz5Si5pLgmD7yMeu+/fXcid0stewNkQNbpoe/Vv3vty9e3KJ3MMAngRtwA4gbABHUqdGAg8eDgh8LJSNjInUx7EeUTFETcEe5J3s14IvalXJ5acv647RewA59jCeHz8mw+vnx9j1LKhNixTR9+/oplKUDcABjSGRxIw6I8hHh0+Xodc6XHH+aqUjjsBNs8rBR6AmXpyskTowHve+9eShG77DyaIctRPjF79nXjPxyB89vL19kqPuX2CYC4AYhJ2GGYg4Mevpu0+R9X2DQGbG4Fe2q0paTm3MmTpTlffE1cvvv2Zfc7b1/KOJztODE42tcN5yKO/vPKDQROCnxyfq6KuAHEDUC2PLOsSPGjz+bZJjwmv79Srfx+rnrgFzYx2Jg/ebKWxjV8++2LLedJvldXX44SQoQcvNmTPXIH19HvEDhpYCJuWJICxA1AAtr6zN3yK5vBbxnYxuC/HWEj3MDhlWgv2MBvpZdmdf7kaaqneX/r7YumXKZyPqrrFzUBwuZM3EqB818InHExmSQ8w1yAuAEwxRqeGQ56awYG2jsYLBn/2xUER/rApgvKkCUpKTyWF06eHmZxTe+/fdF2PmPRuYL2kKjRhI1PckmB88i5H7x4yTERh3huAHEDYMr33r6UA2gnyoegDXhVLGbOf+nCJn7gUtt2hMfV06eZDm7feNM7bmHZS/gXJHL8X8t64Mieo99fqSJwkhF7kvDh569amAsQNwAJkEHFo5ak1I8QN+MIm/jIAW352unTieQ3WXrzvFt781zmwmnqy1EhwsbzNlWcf47+Zw6Bk4C47QivDSBuAMbgoX/GHpb6/7dsB4+NDL61zYVN8/rp04kJG53bb573dlL54myChE3vByoG6+gPCJzYfHJ+roK4AcQNwATQYy6GfzcUh8FAFoP/TCZsdm+cHq9N87q//ub5luXupBoo/wBh4/2+J3D+iMCJi8nk4CHmAsQNQEK+/fZFa9SSlDbQEVQ8ApXw7khtnxbhD0s/yHKtenq8kYfr/+vXz+Ty1Jqlpf0PETbeoyJjcNTBnxCN6fIkAOIGYAx8J0gHBd1Ypp3zzPEfStgY2ckWa4unx8083cfXHIEj3EDjrqWlLw4OMu591Ttw8ykCZxRxJwedDz9/1cFcgLgBGI+QuJshmVP93ZUbVcw1zONIYRPoDuvlsFl8lS9h4/HV18/aljp004oWNt738uDPg+P5RfLghFOPO9nAVIC4ARgTZ3A6HPF7fVCrY7FB2nE8NoP6pmsLe/nmq+PDPN/XX0qBY7kenBHCxlteq0oPTgeBM8Q/nZ8zaTfE2wDiBmBcvvn2RbvnSbBCvAzWwIIVcTfDHIj4S1GOsBHL773qFGI3zFfc61zSzyELETYDmYyfIXD8mIibFuYCxA1ACkjvTcRylM4K1urz6PL1PYOBqyds/qIgwsbjy686HeHG4LQt3zlUQdmVnX9rMsj4+fxNBE6fj2K+rk28DSBuANLjYYDgCXpUSL/v8pvL14ZO9w7FdoXNlwsmbDwcQSaDi2UMTls/NT4kyZ9EenAOqCW9JSkp8uK2mQdYDBA3AGlhicP4LxV3Z91c/37p2k5sYSPsnrD5SkGFjcetV8ddFWTcHhY2lrCGTxevv5y/uUfjMvJ2HmIuQNwApMT7vXOGrOGO1QpaoLJmemnq15euSVGzHvPlPWHzl687pcg4e1MKHDfIuD0obHShMyBwGicLsy1wrPhLUnILOJmJAXEDkHIn/GBEvI1H9fdz1eos2ujfXGETa7C2lbD5q9fPSjVgLZ4eewdutj1hE3gOlXWmjaXAWZ/F+vKpuyQVdzKA1wYQNwAZcCh8M++wh5jBwOJfXbom4yZ24gobKQC+WjJhc6ZuewLHUkHGvjpjDe6gUhmZd04XbjVmsE2ZtJN9uiBA3ACkjDwhevTs0fL+vzdLtvnXS1elsJG5bCoRgsZ79ITN10oqbDxunD49i8EJ2hZuaQdNKJGz92rh1owFo1ssSQHiBiAH9HdrWJELVNVZORH6l5euSkGz5xc2tu+h6ArbXv7rkgsbj2uewLFEezDfTfDp4jIHzusZETg/Pj/PkhQgbgByMc90O9luzJeXftfULy72hM2RI15qtrCDxIxOz2PzN2+ez9QM/KorcNb6Z1FZQQdseshzqA7eLNyahRw4JktS9+l9AHEDkBG33zzvBiX0C4m7acyASXbssBwltvDLnOWvz5iw8Vg4edpWMTjdoESQvp9VhbvEV/aZwj2hBPEISNwHiBuACbAf1lv7vqv8ca5a2sDi/3Xx6pYtBZwd6+Vrt2dU2HjMnzyR9z90FlWQF8d51N4u3CrtFvEfX5iXgjju8hteG0DcAGTN1988bzlPnRj6Ri5AlHJp6ucXFxqOptmM+fK12pvnTWqOEHN9gTMkaLwv3N1Ulnw03l19r6xbxO/qoniEPibeBhA3ABPBsuJuS115OrdYLdOt/8vFhZodf8v32hLCZoArrsBZOzuiwRMz+r6pPjuOwCmV9+8nF3qBxI2YL29++PmrLrUGEDcAk2HX4LWNstz0zy4uVGz3TKTKCFEjH83337xA2ARw+eRJ09Ewa7qYiYjf2vvs6ntl2kG1Mqr+aJDbBhA3AJPib14/k7PJoYF7cFA6G7rKlPNGCptqX8L4Bc1ZgGjzm29frFFTwrn08knTqRvbUcHF6ue9rfaOwCnLDqp7w7UnEBlI3KKmAOIGYII4A89+wEAU9MLK8fxio+j3+/DCglyKqg8LGucxOFK1v4WwicWFl3/ckkIwqg55AcZWzGMt8sxPLszL+lPzas8IgUMgMSBuACbN114/k7PKdn8IihRChfbetC7MS3G2LkejEblsegGz1A4jgSOFYCvGS1c+v/reVsFvN26AfffDz181qR2AuAGYDvcHptjh1J7NL9aLeINH7rbdnQhBczYgOb9f/fbbFwSAmrPaF8qRbH5e0ADjn16Yrwov/mz0Tim8NoC4AZgWX339TM4uOzFfvlm0+/upu7Nlzw4NALX7wsYWy999+7JDrTDn/Ms/dpXAiSMM9xyBUy3gbW4KIWKmRRqOZwNA3ABMlpg7Oqz68/mbRdv1smdrMRJh8sZ5bHzv3UsONhxP4EhhuBxD4EiheVBAkbwyJIlDhA0ZiQFxAzB9dsMGpICA48LE3vzkwvy6HXT+z3Dczcb3371kpp2OwJECcSPGS2ufX31vp0C3ti4GvH+RwcTb1AQoAxYmgKLz+yvVLacmb3oi5py3Ddwa3hrusHjt9GmuZ6Y/Pj9fcy720bA4G7qv5t++O2FnVMqowOE4y5irjiDKdQbfowvzMjfSsbe0adv9lAEBAufww89frVIDoAzguYEy0PPeWDHUupXz2JtPz885g5E9sOwRMhC1ETbZcF5tEY/x0iLE35x5bWLE2xBIDIgbgLzwldcdKWyaMV/eOFm4mdsBSR2tUNWXnwZlTu9J7oxiy3e2yOWpUXFMvYDvvN7AkRtrc2+wBoUuSbVI2geIG4D8YTLrzKX35pPzcw2htuva4eJHPpZ/+O6ELd8ZYrCDqp7j/Dcybqti+7RxCMTaQKkg5gZKwx/mqjtOhV63ImJutJ8vzZ88zc0OI0fYVJ0nGWdTEWfXOXiUo/p6rf7ZaZPSngyOcKk7T0cxXrrsCKJWXq5beW2OPXFjK3ETEm8jvTZ4AqFU4LmBMrEt4uUqkTIhb7td5PJGZWDQGV6aaiJsJosSLHF2UMn4mzydPyW9k5XB6hS6JIXXBhA3AHnlL151pLCJuzxVf7Vwq56H6/7k/NyW8J0bJYZn1+3lz04JIJ6OwJEB66N2RVWFGy81dY7cbMTrA8I4fEnqkFgbQNwA5J/QvDc9rIGnqcfeOMKmFnQd9uCI1DtagaKdKlJYjlrGbOTkeIZNf12yw0XzBkULiBuAnPOegffGETj11wu3GlO+5L1gYdP/Rgqbf/jstEPpTg8VYLwmRi97TnV5quWe/N0YdtQELkmRjRgQNwAFQnpv4nbam28Wbk1lMFLLUZFHQjhD0vY/fnbaokhzIXDiZDCe9vbwTV0k2z61rH0pRRqxNoC4ASgKt14dx+64LSGqlpvobNLCJnA5alDYiNYHn7/aokRzJXCaYnROpZVpLE+1Lsyv2KNjtzzu47UBxA1Awbj56lgOQG0R0tP7Ovx7b6/eqk74EvdGCBsvzwrkjzgJ/ia6PNVyt37veHV7MJB4aElK1q1dihEQNwDFHYSiBITH2cAwCeIsRzms/d+fvyJRXw7R4m+imPTylNwdVfXX75BA4o0PqVtQckjiB6WmM7944FTyleEkfv3vzwk3YZ7D8sWME7Gp5ahHI1626ww+7GLJOZ9ffW89hijOPLlf68KCI2rsRwMJ+8TgIZmauGk7dWuJ0oOyg+cGyo4UCTFmqb2ufxIz7VGDoVzuINCzAKj8N6OEywSWp+wdeyhhX7jXhpIDxA1AwameHnfEiK3h2kBQ/SzDc4I+OT8nZ/r1ES9bY8mgUIw6f6oqMgxYb11YkIHLK0OCJjjWpknCPpgVWJaCmeD5/M1jtTNqaFnK9zN5wviSMyvvpCxsemf9CN8M24eMhSDQs2ConVEHI162pLaSpylsKmo5qqqLm95DEzdK4EgBtsQOKZgV8NzArOALALXDvs0qEHRnhLBpIWyKiSNa5NEMzRjlnzYylcCQsAnx2mwjbABxA1Ayrp8+bYnR5wN51NPMU/LJ+bm689SIeEmc3TeQb2QsS5R4qH929b1GWh/WurBQcwTMesAJ30GxNm2EMyBuAEo8ANmxTw1PNRB01KydWXXBibk9fOddanXK3vOLmAivDUHEgLgBKCvXTp92LEdIDMQmhL88leUpFUQcldOG5ajyCJyWiE6OJ+vU2MHFrQsLW16dGt4VZQ8IHuGmFWhROjBrEFAMM8fL+ZtHliXqEUHFesNYVTEVSYTNqCBigjxLhvL2yTxGVf/v+kLEXrz48kmiMlfLUY8G8tmI0CDijqpf7L6DmQPPDcyipDdx04+zPLUpooOIWY4qGVHLU1ZfjIzhETRajiKtACBuAGaFqydPVaK80B1TOomWpz45Pydn7lFLECxHlVfgtERI8LoSOPW3C7fqpu/bujC/JeIvRx2yHAWIG4AZY+HkqRwo4uYdSXLK86ggYoI8y4303nSDBY4lBYjR1nBH2PROkQ/KPGwPHwbL7jtA3GACmOUByB9cbA/GLOjI5alqnDdVW7+jxJBcjmpj/vKilqdCBawlRO3Nwq1GTGEjvYcHQXE2/uUo9cxyFCBuMAHMKvNny1O+qXAwJstTmxG/64joHTVQHoHTFBFnT9nR9WSgPuknfuvCJmA5Sh6xcIj1AXEDMNMC58mWiL88VVcnQYeivDb1iJcwq54torw31dcLtyLrU+vC/IqtYrfCDsP07Y5iuRMAcQPQo3f4YX+wsKNy4Ow4Aicqb01ULAVBnjOGOk9qWxM0A0jvzauFW5UQYVPxdlYNLUmxOwoAcQMQxdzJk46tBiBbiMjMforA7eGfnJ9riPCEfV1m1TPLrvAHF1tnT6GJ/Wz3MM7KkLcmOM6GZH0AiBuAIYEjB6C4sQpSwAR5aKJiKO6T02Y28QcXB3hv7p0u3BwQy0futu96UACxPSxs5NlRCGcAxA1AIHL3VHfErimPxufaQYjKa1MNeW1HEEQ86wKnKUKCi5X3pqEJm7Nt30HCRgwKG7Z9AyBuAMK5cvJEDhSr+sgxgh1te3hLhB/KuU0sBAj/zjwN6b3Rvq1HCRuf6N4grQAA4gZglMBpibP4GzvO4ZoyLkKoJafVgNfITMRNLAsqc3FYXai+XLjZUOKlGSVsNA6pWwCIG4BYXD55smVLT0w8703t86vv7SmB0wqYnW9jUfDwAtet4F/2Yrb+/rNTuTTaDBM22rZvlqMAEDcARqjt4SO9N5Kz+BtH4GyJfmByix0soHPh5R+lKAmLv6q+mD/z3mxHCJte/WSpEwBxA2DE5ZMncva8qo8mIwTOnpb/Rs6o28ysIQgpXOzw+Kxe7M0/fnbacYTNYYiwWSPOBiAaCxMAhPN24daW00o2rd5xhyMbjJyVL6mtvwDh9erqrS3b7h+E+X+kj8Y+i7NZvn76tPXp+TkZWHzkEzbyeAVEM8AI8NwARHBJHs9gy2WmWMtTVaEGI4BI7IDEfn163psP3CXNjlbnpLeGfDYAiBuAVFhzZtWd/rgUyVmAMUCEaJbC5n7Ir1eezS9WVV3zAtJ7aQqIswFA3ACkORCt2sLu2vEEzkCCP4AQQr03Wt6bQ/WaNTJcAyBuANIWOG1nxNkISH0fxt6IAzZhRvnk/FzvqIXLId4bVa964lh5apac50MsB4C4AchC4DTdWInYAuco6IBNmHlhc6SO65D1Zzdk51TleH7REzgdLAeAuAHIUuBs2LYI26I7NEAhcMCHjMfqnR0lv5mLjr25i7kAEDcAk2LNtu12TIFTUwMazDifnJ+T9WBFfVv1vDdO7WmK4HpUfzq3WMVyAIgbgMw5CzC27W5MgbPCDqqZFzZSyDR8P+4FDc+fPO2IgTOnBmpSA+sBIG4Ash6kdpTAkQPSsitw+jlwInLhsINqduuM9NYEidua87t6T87YAWeQuUn9WJoCQNwAZDpIVZ2ndbW84O6gEmLDDjkDKEDk7CFwZq7OjFqW7MXeXD192ukd1jqobSTVP85V61gSAHEDkBWeMGloHpymkGdI2X3/jR0gcjShs8MW8ZkSNjJjdVRAeV2JZgmBxQCIG4CJow8y615AqBQ4toyZsIXwe3EChE5Fnhf0GQKn7MJGCpq9EcLGo+e9uXb6VO7C6wgx5PVr/GGuyo47AMQNQCaz8Krvx3tezMTlkydrzoB0aKuRybbtAR+OLyanJ3DesUW8zMJGemziCtizemVHHMmAZQEQNwBpE7Y00NEGJnlac/tM0nieHCV0fEdv9gbAt1dvIXDKh4mw6e28639rN/1J/VSt+QizAiBuANImaObc0rPHXjl5Is+eWrbd05sHl6Vsn9hxHzXnZ0dvFxA4ZUEFm5sIm2X9MMwbp8fy66CjFlZ+z9IUAOIGIMUBK2hJSrLv/8EVNweOXKLqhgUW+x41253pQzmETcNQ2LQDfne2NGUPRt+wNAWAuAFIjaBBpesMTM2gFzsCp608ON0wYaMjBc7rhVsk+ZsdYSNZCxE2onp63LZtd3nTV1HuYGkAxA1AWgTFO0Se0jzn5sBZ9ntwNEHjFzqNVwicWRI2o0753h/WNnhuABA3AOkMXDLOISiG4sGov1UCZzXG0pQnchA4xasfjQTCphnjdYd+MexQ+d9XbpBCAABxAzA2QbPlToyZtydwWqIXg2OPFDfq0ThduInAKY6wMSmruMJG3Hx13BFaYPqI+ggAiBsAI+6MmlWPYt5N8rc2St5oG8YbJwicXPNP5sJmI66w8XBqwr4drz4CAOIGwIh6wM8emL7JwslTObCtjViWcgc1d8t44+U8AiePfGoubJqOsNlN8FGHQ3InuD4CAOIGIB7qzJ+q78dyl1QryftJgeOIljX7LN9N8EP0BU/jBQInV/z4wnwSYbOW5LPee9XpCLU0pU4I7/G7KzcQOACIG4DE1EfPps24ejrag+MLQG48R+Dkgp86wsZyhI0l5H+i98hK2Ih+HdgXYijuBnEDgLgBSMztgJ89HPdNPYETMJCFCpxn84sInClypHtsrFh/MrawUbSIuwFA3ACkSdC228M03viaI3BsnwdnWOQMfNXoIHCmQuvCwo6Y0FKUny+/6shlqY5PBLMdHABxA5CYuu/7tn4O0LhcHxA4/sM17SAvTuMYgTNRfnZxYc8SYt1bhuo7bazMhY2mZlr66fIOld9euVGldAAQNwBGqPOkhibxaX/Ojd4Slb02Iu5GP2W88XRu8ejJ3CKHKGbMvzjCRpwl6BuUNcNip8da6sLGLfaHAVmu8d4AIG4AjAmaGT/M4oNunB43hYrBCRQ43k6q/mBXd56O/sgp0Znx84tXe8ImNHB4+IdrpnlsDBgW1fJEeQBA3AAYMhHPzZmScgSOI1qWhHfYpm9ruPALHtEb3I7+gMBJlV9culr5xcWr8pT2hi5kRuyOylLYiL983dsS3vXVg9uUFgDiBsAU/+CRarxNEIvuadDLzsM/kOmiRkXjnAWWPvqfuSqz+BT4V0fYOAJGCpt6mJDxx91YGQsbrR60hBhYmkLUAiBuAIzxDx7tSXzozVeOwNFOE9cFjSZq9CWqqvN09HsEzlj86tK1nidMaB67KG+N8/Ou81j6YALCRvGYXDcAiBuAcfEPHo8n9cG3HIHjPC06YqbtFzQhJ4xXnH+O/vtKtUGxmfNrR9hIj40lrJrllzAicIeU9Kwt/+Pnp+0JXmbr7Cu1Vvn48nW8NwCIG4CxmORAJgVObwB1hrF24M4pMbCDyhU4wt7731duIHAM+M3la/KUbemxORMKVoC7xhqsB8v/8NlEhY0s347w1QPBjikAxA1AXD45P1eftriRvPeq4wmcZlCSP2H7Y3F63+/915Ub5MKJwaPL16UQPLAC4lesgB84/7edx/LfT1jYSL72+lknKNkjACBuABKTdTBxGH/hCJwvv+qseQLHViOctzXcH4ujnhu/u3Lj4D+v3GDZIoTHl69LAbgXKmaGf9aUQrP+2Wl3ipfd8n2P5wYAcQOQ2qAycb7iCBxh949rEOEBxt5zb7nltwicAX57+XrlPy5fPxAqh02snMOOsPnhu5O1O5+ddKd8+d2B3ADsmAJA3AAYkMsZ8Vded5qObFl1RE03QMwECZyaMxgeO4M5M3yH38kjCyxLxtesDPwiQtVYwlr7O0fY5OH6bbVjKug8MgBA3ACMwj8jfpiXC/vL18/kwZ1nW8VDd1A5M/zew7kX53H02I0vmVn+68qNuvP0yPIJV2tYzHhf9uKdfvDuZTM3N2EjZwAQNwAl5a9eP1Nbxd0g5+EdVLbfiyMFzl778vWdWbSX2kF2tiPKGv0nbedFy99/97KVp/uwh5dHyVIMgLgBKA9fff2s+7XXz5ZsN9BV20FlBy1Pec/rjy5fP/rN5WszE6vx+yvVPUtYJrvHWnJH1Pfevmzn8X6G8hsBAOIGICGtvF7YX79+JoOMN0R/GSos/kY923Xn6dG/uxl5S8sf5qrV/5mrPhKWe0aUFe/Pdr/99sXyd96+7BbjLlmmAkDcAJSUv3n9bFce2SAGjmwIFDYqHkdUZRzOry9da5TRHk/mFnsCTsQPDJdHKax96+2LDaQMAOIGAHLC1988b6lTxdvBRzTY/sR/vTicf7t0rVQJ/57OLW6J3lEKg0s2EcKgI5eh3n/7olmA22v7lqU61HwAxA1Aqbn95nlHeXCaurdGDAubgYR/v7p07dG/XrpaLfK9d+YXK8fzizJ/zebwb+2w71rOY+kbb160C1K+Xd9dPKPWAyBuAGKPlUW98JozADoPmZdlTebD6Q2Ddqiw8QRQzfn60S8vXV0p4j0/m78pl5/kMtTKkIAJd9lsO3ZaXhoQDPmmffl6PUKzAQDiBqCc4sbDGbSl92bZETbtYEFzJmz0ZaqDX1y8uvO/Ll4tzC6cF/M3tyxX2FTDXuM7j0nG1yzffvN8q4jlSgI/AMQNQFoUcmfR++5yy7K+XTxE2OjLVuvOV0c/v3g11/d8snCz8nL+psxds2kPCQA7UNgId5v34t+8ed4qdnW0vf/bNE0AxA1AXPyDRmHzibz/9kX3m29fyO3icqmqqx+2GSBsvO8dYWMf/cvFhfU83tPpwi25/HTsPOrDwkaECZvtr71+tvzXr591i1qWAd6aLk0VAHEDEItpnQCeJd96+8JdphL24DJVYDyO7SWI2/nniwtHP7u4kAtx93rhVuXVwi2ZZVkGDlf8/hn9dALty47zWP7q62dbJSjGum9ZCs8NAOIGwIiW9vWdMtzQt9++aH/n7UuZ1XhXFwMBwubse+dRd56OH15YmGqw8ZuFW/I6ZGzNeu8afUImxGMjz+Fa+qvXz1rlqZZnSlR65PDcACBuAIzoaF9Xy3Rj3337csMRB3LLeGeEsBFKBEnPzUHrwoLzmJ+4F+ftwq0t4Z4NVY0QMvodyEF/9SuvOqt/+bpTGgFgD4psvDYAiBsAYx6XVdxIvvfupZf073CEsNHFz4rzfHx0YX4iXpx3V9+rvbt6S3prNm1NgA1eY39JSl1qy3ksfflV57B8VdKuevdJMDEA4gYgCS39m0/Oz9XLdoPff/ey6zxWnaFy1VbBqRHCZmDL+E8uzMtHJl6cz6++V/ns6ntbzpePnGuo+T01IUtS8vo33nvVWf6LV51O2crqN5evV30i+yFNFABxA2DEh5+/aovB3Sj1st7rD96dSC/Hon3mxQkVNvoyUM+L8+Pz6XpxHGEj7ay8NfbQERIi4HslRJduvTreLW+N7CVa1MVci1YKgLgBSIK+tHGnzDf6t+9Oun/37mTV+XLVETbdKGGjDbAV57cHn56fO/qn83PVMUVNxXnInVBHtoqtEbbwiZlBr40SnxuLp8fLN18dd0peFz/SlGX7WwQTAyBuABKiu/7rn5yfq5T9hn/Y9+I0w4TNmS+hLz7qztMjxz5bCYVNQ7h5a9b7Isb27YLye21cb031tMzeGqHfve4he0DTBIjGwgQAwSgx8yftR2sffv6qOSv3f3RhXoqWPVvFegwn/QtcrpLLeRuOnVoxRI18X3kqeX1AuNj+5Sj1WW4wrUxEuHb99OnhrJTDby5fqzv3fqSJvcVvvX3RoYUChIPnBiAElcxPFzP3Zun+lz879XZUbQcJmxDksQ1HjjDc+yRkqUotQW0JlWXYQNhIL83iLAkbZZu72rdthA0A4gZgXPb1gdsZsGuzdPN//9lp13lIIbLYWwqyBwN79WcfDeexEyBsvKMTNrXBe5Sw6Z2Rde306YbzmKlYk99cvia9hw3Na3OfJgmAuAEYC7W8os+U782iHf7hs9POP352Ko9vkEHHnRHCRtpr1bHdqiZqas5DJuLrHZ3g/e3/iRY2vYDhq6dPl5xHaxbt3jvItG9kaY9DWiXAaIi5ARjBJ+fnpBdiT/vRojNwd2bVHv/kxiLJ4N97YvBQUWmTbT0uScXVSC9NQ/gE0dl2blsMCRvn313neXvh5OnM7gqSXhtH8x3b/XO0tr/19sUWLRIAcQOQlsCRSylV9W3LGcCXsUkvpkYuPdUCRE1FiZr1IFEj+nE0/i3mLeffjfmTpzOfgfffL1/bcQzi7SCTIm+RLeAAiBuANAfyunDPN/KQyy4sEfj4zBU1UtAMeHX6AsYeOoVcfS2XuhxR8wSbip7XpuaIv0eafTYcYbOLZQAQNwBpCxwZL+LlG+nNpNWOqpnnXYio0QXNoMg5e+44T9tzJ0+aWPFM2MhlqCOhjp6w3R1SS1gGID5fwAQAsVkT7tblinpIsTPTy1NvFm5VLXlUgm03gn4fdIK3dhbUfbm9e/7kSU8g/vpSb2dQ5Ztsdd7RhI1X7wDAADw3AAZ8cn5uRYkaj+aHn7+aucHnlRI1QgUKWxGixve9TMIntzOfiZpfuaJm3XmPe86jYsncQpbYfv/N7Imc31y+Jrd972lB1gQRAyBuACYicGQQ7br2I5mRdybiIU4WbtYsYUkR0oj7N15MjXBzBp2Jml9euqqJGkuKmrMOybJ6X7ecf7e/8eZ5a1aEjZAZofvC5tARNqu0OADEDcCkBI4ef1N6gfNi/mbD6SzuOqKjHtx5hPpupKjZnj952vR+8POLV6WQcUWNJZSosc7e5UzkWN7XVsd53na+PKy9eV7KGKdHl683bGHv9TNAi7bzWGZ3FADiBmCS4kZ6HeTuKT1jcamWqJ7NL1adLqInapxvq1ZQp2GFdiIt57G/oIkaTdzUnL/ZsWT8kqULGkvon9F7KJWjvu8dh+E8799+87w0W8UdYbPlCJtNXdg4Xy1/E2EDgLgByInAkQPTapGT/B3PLTacnuGupc598nwqVryOoyc+4mQU/sXFq454EpuOgGn0RY0V5r0ZED3SzpYbu3P49YJ6cxxRI+vPnnvi91neH4QNAOIGIBcCR8bgNLQfy4Fpu0jLVH+Yq644ncFHjoiQz72t3JY13ElY2lfW4P1KodG8fvrUWNSp2JuGir2p+r03usDxe4/U86EUVH/z5nlhcuS0L19fsd2s15Wz09VtdykKYQOAuAHIi8jZEtphkN4YJtxYnFYer/m/rziCxpKCRvQFjU+66AG+AZ1GS4qKG6fHzbSu6V8vXXWuxbqrrqkvcgaXp4YEjvtrq2u5Zy89kNf216+f5U4kOKKmLuuJfXYa+pmwacokhggbAMQNQN4Ejhywzg6G1JDi5v60Mxr/55Ub0itSdz00vedKTzBYIswjMuCfUV91nNfLXU/NxdPjTlbX+m/u9vCeN0eoeJ+YAkfv1KRH56G0/9deP5tqjM7jIVFzdrp617bFxvtvXzRpQQCIG4C8CpygZSoPKQakwNl3hE7mg2378nUZuCsfd9zgXXfJxxoSBcpLEyBy1Ndd5zW967716rg1aZv++tK1Wi+o2ep5c6pDXiX/sxX4+64SmQ/lFvOvTkDs/Idjf+fprhtTI6rDR07YLed5bRbz+QAgbgCKKXJ6M3Uh+lunfXSt/mDbdgbs9j9+fppoSUImwVMiRoqX206rlrloaioh3qCYsawAceN93Rc56vqk5+PBX7zq5CaWRZ65JAWDjA0SATu4Bp6t6CBoZX8pcp6p544jehILjd9euVEXti2v77by0FQDjptQR07Ya99486JFSwFA3ACUTuTo26Cd/7uu0On9TOZ2eWZpy0bq8UUlXOQ3nqiJ3GUUKGaCRY4c4FvOb/b/8nUn91utH7mekbraql4LEzj+js4a3RF21MPbvfRn/+udn39R9HfJyaMSKr3tTiLw/CzvWYqZ/aU3z5u0DADEDUAZRE5VuPEjPY9DmMDRhYzQxUlAPphBETNa4IhhL44UUC0Vl3L4tRwG4Malffl6RW1dv6MET02MEDlJOsDQYyVse0jMqK+lTQ/lkRNLJcrNA4C4AQC/0KkpkfOR3+OgLxv1hUgygdN/z97P5SArvUIPPQ/N7ZJm+5U87oudmhI8vWW6MJGTWOBookb7Xc++ztcPawXang6AuAGANMVOXS0v3ZZ5XtyYmcF4GX/Qb6CQUecxqZ9LIfNnFVfSeZ+TtmWAb0V5dGqOsSpK9EjqozpCv6BRP+sqISNt+0wtO7XLLBoBEDcAMBY/vTBfEf6YmuBlq/b3371kQB2T31650bN3uMI5EzXtryNgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgh1iZvOsHH1ecfxvO4yPnUXcebfXYFp/+qJPg/eR73XUeNefRVe9133mv1kyU0gcfV51/7ylbShvI+37oPHYdG3RzdJ3y2qrqGiV3Al4lr/ex+rqjHu1c3Ue+60FVfVeP8RdtZe+uY982BkylX6sZ2N+r3+W0/2C/XJngJ3v12vv6Wa9PpI6HldOKGj9qqj4+yN3YUQhx43YAR1on4B/YNhyjNg3eb08JpSDWjN6rmBWzpuxZCek8V6fWqD/4uK46+TsxO/souppoo6Nyy13a9LYSNPUU3rWt6sxDJShbAqKEpGf/Wkr276gyeKzqeKvA9onql6eF7EMOe4P3pz86pBL3ymnL+XczpC9YLrPAyULcHDj/royogEuxPDjhBaOzXNpO2hWKj7TZevCA9emPliY86N5TZZzlbK2jOqr7ibx9xSzrFSUUs7atzqGaybVmws6jZ7iet7k6oU9tKfsfFsb+8frlaSNtuT8LHooR9fkgN2NHocWNO9s5jvFKWeE2Yrzfn2J08rLiLpayArtu370Yr1zNfKbiXovn2pw0cgDYLqWIdTuguyMmBJO0874aaGdjQHC9j3cnLCjDBxvX/s1c2z9ev5wXumqCtDWD4iZOOW2X1TZpi5u4g7GcJS7H8BA8ij37/PRHqyWsnHFdv9lVULfz35vgTLb8Isf10qyrQbWawyvs9gbYsnrN+jGB93Jqf6Hsv5+7uu72B0cFLHVZj9dmKE4z7ljccWyyWEYTnEv5/dLsKExmBitOYa6XsHyqU2wcVedxpDqyvAwAbsf6wcc7aoAqWodTVYJVejc3czyweuLruHe9rke2HKLGXVKR9t/Jsf2FEl9HvTboCgoYvy91+47ZYDO2XVwhhLjJdWGWpROe/iAgXfSPRDpBlFmw3ru+onT6g4NqQxTHpe8NssUWOYP23yyY/euInJT7DteWldLeoVtPTNrqXcRNvpGV9YC2O3bD2FN2zHvj92Zi6zm357o2qBaZhhKUW4UaGNxZaRFFTZjI2WMSl5otyypw7hnbo4TC+VzJ7qemZmiQbHZ7IPK3vXMUO0qQ5c2esi4+Eu7yR1k60YoSCfn3mvWXVfdKZH9dZJZxGX6yY0UZBY4rfJNsTiid9+ZcCSvtJu7bBMLGja1ZKegdNHIlcFyB/UhMZ2fZJKiKPMc+uQN/npdV0xCZO2p5pUoHhsDRuJfw7xplq0tfKGmlla7bJbLeGtgr3YG4JQYzEfu5oQbISoqfKxuncMp8bcoi8WBCg2pL+9qztWdXj6yvY124Lu21XCRddO2/NyGR3vJ9/zDA/lWRbdByXbhenLWcJq1bzlDc1ZS962PauKba7LIoOv1dgMn7UCG2EDf5n1nK5YA1AaMaxM6Yg4GXFdTLLNxJcA168rrqWI3zg48fO9ewOwU71kU2sUodNZBK8eIeY2Ii2vtHBtRFOpmkw2a/G1PNFu6mjjjIQEyMZ//+tVWV/Wspl4ErqD/4OF7usEmS7bbrQ59974rkwfr1nre1+PleGmP2P/fKJG7SznMjDRMncDJOnpu6GD+fwmqh03C7MQNxOsJkeW5GZ7AcNXPdT31A65+DMs4AMNms1fFzSsTFS+aWTdbafibetBPXTWeAde2fZmyTZ/9sjgFxBWc9gzJoqT6vm6Gt4/fLn/7ImnA98FIYbBai30j//o9TEPelOdKojDE3OuwsiO4IkgzI3pkky5k0AilGXeG7rGbNSTiY2Dq66/lKQ9h0eiLVzba91PM+ZZVAz7XxWu+zXO9mWp+zPvHYp76wHLe8uz1xNmj/dkb2756Vwac/+pIqgzQGVVd4lHmb82i7yknekuqnTCluDhx3wpLGWHevLNWh7OIm6QA+CySZ6W6rjj/72Y37GUtqwElS7tnvJnEH8nE/p6NmS4u9jnmSGYHdwaCpMpSmJXIavV1ikxhg0xGWnv2/1PM6TSMjs1sGy6q+jzthkEs0x2qpZjZxRelyAlvWCrwLLS1RUivLhpxzM1DV62ybHBoU6sIs8KwrXG/N1hRmYhsiWezURxMQNo0x3kEXNc2p14lBkTPuskb2u1DGF5bdXNnfG5T7HrVxltMryv6zLHC6ypamZbtZOM9X/wT7tCjFtvBzM1LVd2a6oQc1YDOmuxbtDj6muxmyK+/xhI0cVLdzNagO23pRuEtk4wqcg4zs3xhTWHrLf81ctk7pPXLPypN1PunSGALHteWaoVCUditaSoy0E4SWYlv4uRmq5nszuxY9nsrPxzZfV1yt5cB+62MMrPIelnK/K6Mfu7AoxosFqaeeVHO84O32mf2LkCZC1nm5DJxcaFbo91QfZrbkWpxs4uNv/w4XOIibwlATxU+BnwYma7OHuZrdutcS93paqX9+f1dOMm+BG4TdKUxNcT0I0nsglwa7E6hvo+xfH0PY7Kp4sXbhWmw/SDZJ3SlnJl5TsW42MaoWyOOVVchF4QOLz81YNV8ne7GR12Yjh9cfd6B9kLKwqSUUNtOJV0p3cNhVg2sSwVhROznGtX9VJFvmkvZfzV0OGPMyaKsySBKLk7TulkngtIRZ/E1R4k5MrrNt2G4biJticTCzs5h+Qrc4NHPpZXBnYasjBE471UR+/czDpvXGWwZpFb7uDHpxkgyu47dbc/t7wvKwFO3XXS6UdT9J3W6wscJoeS//cTeu+Kga/MWq4QSl0N6bWRQ3s7w93GSQeZDbu3DFwnJIQ90V6adS3xPmOSS8fECdUtWgvhfH5L7Gs4G75buWwP6LhVyGGl0GSXcQ7sz4DqqOweBeLUBQrYnXxksIet9ovCjwSkdZxI3pzHhlRmcxtQxtOumOqq3lBvGS/i2qXCXpBYu6syPTWZwnbMp5tll/iSROHfGO50hqf9m5rmP/oTJoJhQ4sx5gvJ9RfzlZ3HZhIjzuq3pzaDjZKKz3piziJklujs0ZnMXE7dQ6hRkYXJHTUo9Oqu/tDgKmsQrlH1hdu3eVuGyOeGVysZksi/Zs2D+5wJn1jRWHhrbKK2axNoNL4ybem5Wibgs/V5JG3hHmsQBkL44SNyCEeVr/zswMrP22t6baXifAFqtj7raTg7BJx+ol5psl+0v7mm4VX5/Z5Sm3bsTt376Yy3twxUbD4C/8YqZp6AwopPfmXMkauan7u5Z6Hg4oB67b12Q5ytuV0505W7nnMMmcON4S4aJKUjjOclRNmC9HLZcyxma0/beEeSbeWZ7YxRU3eRWADaN79U8w3D6qafR5BVzKLFtAcZLzcTbZHg4pdP4bMzmwDnaa7RSXB3ewv+H9m231rRV9q+8YFL2emHhSwmKMTJamipi1uWTixjxZU38gI4tnEWYsk8F8i2Uzt6n8i2l/2ZGaTDgOU936X9y+b1SKhKCJ3Sz2e38ueN8Ut8y8k+6D6ktHmK10FC5O61wJG3lLmOeBqAribwaVehqJ14qLSUPuiHwmOywyJl6bpBOaMgocWRdN4m9kv8ehwuXtmw5HLJPfN6orBVvhOFfSRm7qopWszMCA3iqzUk9xZlQ1+Iu1mYyzwf557ft2hWmittnz3twpaNuoG7aN7RiOgLZRXUHc5IIk28P3ynAaagSma/Kz6M0yEXXNUmQfzhcmW1xbpck+nH7fF5dCxlOMicmyTp64Z9g2OjFeV9pt4eUVN25w4XaCSr9XYpuYJlRrzJTAMfMadEXy05ohfGZaz2gQnx3Ml6dmzUsbN6bwcY7aRtVQhG7HrCtNUdJt4edK3shNXbSi17mWe3u46bEKrsCZDde1idfgfumOViiW/ZvYP5Jdg0GrOjMxdmb3maf6dc/ous08yibem8JsC5+Fs6VMdxC4M5myJrlylbppo204j6NSJ/5yZ0ZxvQbhuxAgqf0rwix/B16z6HbeNRy07s6IZT4yeG17RtqGSV9WmGXMczPSyNkePkjSk50f9bxa5bSLyczoPkGsqWPSeeO1iT9oxa2nK6X3zrr3F3dg7uYob1JDmMQJmaalME/qV4hlzNk4FdwNOjSdaZf3DBbXHs2Efy1tclzCBGAms5GmgLQx8Rzgtclm0Cr70tS6gUjIU6C62cQrGaXbFn5uhpq67BA7xo2hvGvRSbbLe7iB1x98fFwKT4673FbFazA1+1dF/CDPFvbPbND6qOR1zEQkPMjJda8Is+3fyZbLXS9VKyPBhbiZwCxmNcFflnN5qr9cN87yimx0nienyNvoTWYhDwRM0/77mMuonXcMBq0yL02ZHILbzVGKARMR0RxzubxU28LPzVhDZ3v4sD2Wxfj5HLyANylyHvWWrIrVScadsXbJqzJV+0uwvzkmgrBeurt3d7+a3Nf9nFx31fC6x1uudfu2jsFf5Dps49zMNXP3BN2W4V9JlbpeUnukJXA8akoM/smx2UFBhE7cDoSBddr2J5A7CSb19k6p7tyNDTQdhJs5uXqT605rudbUe5Pbvv3cjDb2JMsxZd4e7gmcTsrvvJJ7oWMWGMeSVPr2l22qgv0zbd9dgwldrUR1qyHMve67uYjpMt/+nZa3qWkwNppeI+JmAo29I8y3h5c9e7EUOEvC3KtlKnS8+Jy8BGqbdOYtAdi/mDyM+bp64e9UCgM3s7ppf52nrOMmKwWd1JbLzXfY5Taw+NzMNnW3MphWiFqpsxfLiv3pj6QHZ0Nkd66Kp/YP1G6rnSkHpt2O+bo2SyKZELfsO+ySGov4wrDIHmrXE/sooUdhI0dtfJqpEUy3hedyR/G5GW/wa8J8KWazaEe/JxA5cjthll4cfWCTMxQpco6mlDsn7uCK1yAb4sZ4tDHVWG26lUGbyJOoafT6EJlJPdn1Hxonv8vyXszOuDtMua50DN8zl96bczPe4MleHFXBXS9OEgGYhLqYTu6cuEL1sYAsqGD/iRG3Hefbc+MuO9V7mzzcJe4/CXcJqj6GXfJ0CKvpGXdZeJtMvDf1PG4L/wIzGmdG88HH0q1nEpleVY1pdQbs03TsI1X8ulLoWYuOqiqLe87nygaWl6R5HQFZED95H6RRh+MMQl9MSYTYBbCJm/8sL8tR7pKgiUhrZjgutg3a52bOBOLML0t5BbklzN3eKzNzkq4biyNttCiSZXpOOqPXEwRWMuhITDoRlkWg6MQNKq7NkE3WcnSGlBDmSfuy7IsLvS0ccaNXcvMg2iJn5U0ucj790aKy16Rm0w0lcqZ31APBxFnMUusG9m9hMMhA2BzmqD1UxXS2f4e1uabBRDZ328IRN/2CJHuxacV3Y3Kk0DE5fTgpnifn0RQCuhE2UAbaBm2tzMj2vJSbAOLBSVxcWhPyOJlkt85VYDHiZnDAloO0qZKvl3p7+GibycBjuYXyS8KNQcq6w5CzmyO1hXzcTjju37MkBWUZ1ONQ5mWpthI2eWzTkzj92xSTgzhztS0ccTMM2YuTCx25nVLa70vKjociO6/HuhI549idMivXoAwQxbbTPy3lMl+Su/077mSrM7HltAIn9UPcBBdmkqjvg9JvDzexobtsterz6KQ9SNWUwKlj9FKD5wzGoSVcb81Wjq8xj16bviiMT262hSNuwjwQZu44iSzQTYwXYk/p0XGFjufRSYuKEjgNDF1aqpgAEoqa5V5sYD6XoVzcyVlcL7KpJyWN/rsjzDaP5GIcRNxEq1XTBrE+M9vDkzcU16PT31aeljdnL4HA6VAgiBsoFd7gv6RETasA12y6/Xsay7Qm3qJcHJCMuAkfhMlenPVswN1W7nlz0hAae4YxOHE/k8EVZomiif6Wmigt9/oT10tcjKVMdwnHZEJ8fyrX6a5mmNSL9WmblgzF0QXaTpC9WAqbg15Dg7h2bvZmJK7nZXNMMSGXqNIOGkTcQBmoT1TcfPojK+GAXxfuGVFxeZjzeJoo8pS0bxTbIn7qE3mExFTLBM/N6Aa6JcyT1bnnnoC5yOknCEzqep3d3EPFI/7smt2Is9QPyP7WJObxXiGTqboe/obBX+xP+YpNdr9Wpx0HibiJB9vDJy1y+skBk81Q44lLk8G1TsGkXs4mbYql3vG5HfN1edh6bxKPJ+vGTgHLY8WgXremHj9kvi387jQvF3ETr1A7wjz+Bg/CuA1JJgd0l/eSdLabI2OfGFzzAInlJkdxTmB32+aGkVAo3gTEJNxhPyfXbHpa+NTaLeImfmM7FOZb8Gq9TLowjt3lbEV6cUwDBGVHnqb3hsE1G+La/zamGpu4g38nJ21f9rctg78ozmYOd1dtNXZ55OWoCHeib3ItU0vqR0CxGRuqg6ga/I3cHv6Ag//GnMV98LH04BwZigy5Fr87wkPTifmedyiIzMRNnEEXcTneYJrFLsJJID3mxzFfW1UTmq0ClIjJoC/jV+yC1jy5LXxjGtvX8dyYDrJsD5+m7ZeFmQcnTsBeXBc8g2s2PIttf9rQONQN2lorR+1eCi2TDLmbuQ8udq+vPkN1byqbaxA35o2tJcxPD68K4m/SEjgyAaDJLGDUDCn+SckEiGeBiVitY67E3MmgPCaF3FjQMZpM5ptZy2Q/lcBixE2yQXYrQSewwhEBqc3kTLxn1REzuZZRGUIWk4W4fITBEhNXGLZzWEdMg4vrue1rXe/jrPUjU9kWjrhJjqkHQbJTyHwM+evsDlMTJW7HGbdDZ3DNhrhlWcdUiQZUky3HD3Pc5k3OpNvJ6TLmupjNnZcT994gbsbzIJguT7E9PD1MbD9qp03cwbXG0lQmPDCYAeI9M8dElLdyfB8bwiz3TR6Xf+7OaB2c+LZwxM14AmdXmJ9wLQt5C+ONbXvZCXdii5L0Zqt3MX7qmAyoeM9MMFsGaU85vX+cCaVJnpX1XOW+cZdmqjNcGye6LRxxMz5kL54ecYVlbUSnaZJWvIHZUx+02gZCtcGuKSNMlqQeFKCubAmzuKA85Rmb9YnRRNsu4mb8xubt4DHlgE56bNKMD4grlCoEhk9VqLozcog/kYpPsyD3ZBJcXMvFOX/uZLZOdZxc20XcpCNwWsL8HKSqmL0tgWmT5tlQJunNKbf0MVluuMfEIFadb4j4yyD5XpIa7m+bRu11+hs57lEhJ2sHMhSnx7ZS5ibLTXJN+KFaFgHzTq7j2C+9DvODjzsxBwN3a2NeUqKXpyzbMduPd7TGFoZLTYTfL9i9Se9N3CU372DN1alcqSusGgZ/kWQn7rTZi9l3VibVdyJu0uuc5REBMv7mkXGl+ODj1jTSU0NgBx93jX5TFMeNXyT7x91NGOdojdnFzGsjbVisCZbb324btFf3YM3pZF82ETbNQk52P/jYpO+8N4m+k2WpdBtcW5itB3uzigOMlwuaBjOmKrveUm8/0v4dg3ZD7E3wQGO6DbpZSJHo7lY1ESvTOgbHZClmv6C1zqTvrE1iFxviZvoNTlLPRdAbZdcV5rEfVQyXKmaxT+w6DLaL2Zbj+wW+V5PJZHXigtj1oMUVVK3CHrDs9p1Ng7/IfOcY4iYbkqyZ0lEnm6FOcwZCUsb02TVsO9h/sE3UDAfwZmECiYMH1bYw28wx6eDiWfDaJBHJjazLAXGTnYo1PT2cgdKcmkGZtGK+rmPYSPG6pd927hvVAZYHdbFv2odsl+DO5T2YCLS9CZVH3aCP6hR+g4Lbd5rECzUQN8Us6ENhHjQlO+odjGcgLOJh6kUz9R7gdUsX01OgN3OViXZ67Aiz3ZrbhfbaDAriPB6sOUteG4/7GdkHcZMzNgw7ack6HXVs4qbiNzvp2O0sTWa0blD4rOdekfVWelHcR/LBw9z+Yubt79rbxOZdYZ6bK++TyZaREMyyvrhLLiszVxauhzxuf5tpQlTETfYziiS5FbKJ6pcV6YOPj7THVmEHBLfziDtLbScou13Dv5PXczTDouZY3f+meuz1fpbUo+W66E0Gq0rv82dR4LiHiZoutWyUcBv9mmF9yTIZp4lX4rBkZZEL7w3iJnuB004wC62KNNeFZYf/wceP1HvWtYds3McFXVIxaRRJj2kw3dYvlxVnK27KnXkdieDdOePW4zVj+89aWgW37ZrauFXKBJTuEptJX5uNl9wV2CYeie2SlYOsW1PfFo64mUxhbyXwHqwIs/XzKI4i3qt4M17zjJ+thOUm/87UXdyYGYHjCptR91pTnoVJDFZCuPEUs2L/mmrbJm03yWaHovW1HYO/yCLG0eSw0lYp4p6GMfHeZLItHHEzOZJsDx9fcLgDUC3G5xRpx8+mgW3Gc/l++qONBMK0/AInnrDpC5zxBqtWIvuXeYkqmbCRbJR0MNUxEW9ZHKxpsty1XdIyaBq21yriprgzio4wX+ZIg49iN8giLE+5LsyGwV+ksQthLYEwlQ22nEGuZsJGTM3+ZY3Bce3/KIGwac7EeWiux9VkS3J6uW/c/inue3UKm7Qv3njXNGyviJsCF3hTTP4MF5MOMN+DsXttJjEVnVTOaUl2rIZkRQ2w1dLUYTdVwd6E243sKJME5td6IqBM2/ST2z9pHS4qG8IsGWday1N4bfqYZntPdexB3EyeJLPQcTD5rGpuZ7vuNZm64dPrPFxhmmS7pjfArhS61kqBJnfYJVu+TENgthIOzl6dbhTc/pUx7O/u2pylQ0bN47VWxg5sdScxdYMyOSx5GUhB3TIQmKn2kYibyRd40u3hSXmQYDDOo7fBNEFZ+hk/3fibJO/p5cEp5jKVK8weGXTcgx4Dt5NLw/67Y9h/r+D2P05of9nfLM9AnE1YfTGpe+PGaZl4be7PiNjcz8h+iJucNrqWmFTSJrOTlvPnbehvYzedeW9kZM81kSRvjjc7dLfeF8OL4HprDoS7FJik009/Z45r/+aY9l8vkP2PxrC/EK7Hpi1ml8kcrOmKIpP+sjkT1jcbf6ppbgtH3Eyv0JPswklKkgFG9zZUp9S5eztCTGMmWqnE2oSzPEbZeV6Eo9xmonYF5ZbyFiQVuJ7HoJ1B2xlH4LjxFVIw59v+OyK5t6bf7ssasJrdRDJpcHHDQIA2Z8yTNpWkfoib6bI2wQY+zmz30cSzGbuz6yTCJvs8Hq47eRyBI9SgdZQrkTMoasZxEWcnbNIROEL0l1/zav/1Me2/NhM7o+KxLbI/aX4Wz5GKS9PA/itpTaYRN9OdVUxyB8M4niIvVflx5iKnn8p/RyRzxU8mj0df4Iw7gHgi55E6HmPyMSHSQ+bm5fFEzTjXkL2wSU/g6PY/zoH9/5Si/RE2g201u4M13dfGHZBbM+dNc+1v4klPxXuDuJl+we+KpBl0zStYkkSCQSLnTypJWnoxOe7A8kiEp/KPw+5EO3Vp03QGWM+TsKcE5F7m8U7ugLqubO7FNI07sLcnJmwGBU4au+Kqyv79up2tiK/1lp5cIZ8kpiyIzsTtX5x+timyO1jTJMPu/oyWgEkbTWWS8QVqfS5YVbPmSsYNvONUmmWRLLPpcAV0K2FXdRoP1awkXsfqVl45a5ZJBldSuJ6mimOaRse55tzPQ5FO/peKZlsxYFt351EyceouvUgBdVvZvZqyFVpiWtuNZRbjDz7uiOTevuC67drNs39b2b+D/QvLhhKSJhO5jZEiNX5cVGdmPWru2HMo4sXwecHZY9kKcZOPgu86BS9noAcT+Ky2Ejh7Ip2zq7yKuKIauzeD74rhAyu/qD6zmnLnPv0EZbLT+uDjtirDNO+tLvqHnApN8Hj3/eeQv7ujeSSqGd/97tSE5bD906rXfvuLHNt/Wx1TAaP7vm0RP55MejYfjFhGItYmPvdF/A0Km4ib8jS8Q6ch7YpJnPHUFzgHYrzdGGHUtIEha+RsYC0XM1bXrktqgM1yWak+QftG4SWHa+Vo8FpWHeP6DNi/I9gRZS7E3WWkuIJTegOXAn9jfvr37kxbXtZT18Max/butvAx6jYxN/liW5jnpEla0WS8yLIodgpwuRSVL1e8a9dVMX58U96RonIxdwOra3/pRVqeWFua3iC9hLBJUD/MvLy1iOBiEwHdZMnwbIyLy1iBxYib/DW81Ql/5lZBB4INFUya17J0B//yzdY6wg1azXd8hzvoL4nynd/TUvbfYLAcq22aHaw5/uC7jeGFF9g9kW3hiJv8FX574g1BDgSf/mhRmOeDmAZtNWPdLUBZel6ERTGJHXHZ0lWCcrEw3gLX/lvK/s0SiMq1nrcVb006k6P4fV116PBVN0A8bvB6ayaPvwjHJKlf4uV9xE0+O+WtqQyG7ucu5Xgg2BZF3OoqOzZ3CXC5gCKnq+y+WAhBGW7/tYKKHE/ULJK7JuU6YTbI1ic0mM8CJvU48e7HtMVNO+VGHbfzLSNrU7m3fA4ETTW4bhXaFe96yJZzLiAHB9Uy2D28buf5ntoFFzWdAtSHLYPrrCS2Q7ZHwRRVWGZep6clbh7ENECcitcqcQWIG/h2mMnnuwPBl8QkA52DRc1aqdy60vPUt+0kzxiLM1GQNl8+G1TLGNcxKHLWcmh/uey6lEtR4y6JxakTRemX48btdQLGujh2INYmmLjerMRjm5X6JbsHvq2PaMCLsTpNN0vrqNwvS6XOyDnanp43YBLXIted5TZKWS7VDGes+2LWdhe4gXMryr61CX6ylxr9wUzPMPv2l0kl6xP2cLQKZX/33LedEXVqqTATktF9bLsnNs3tEPx3ENfuzXE2jVgZXbTM89EIacirRmLE3Ya3F9KA1maiQw63Z0tMKytpPzPnHdFPzJd0cG0L15t3SOCd0LM31zT7ppW9uq0ej4VJRmnsn7b9H6rBr11QG4UNTJM7Wyzd+9kSwbuivCNFuoZ/N72+uRz1qDnublgrw4uuq1lQTfSz1SabjbuzqnvajHb2BkJX5N1RIqLTs2ee3NbugODPPnwnoON7rHUaHQbXsex7I0RU6nb2xGMXW6di/4rWD31RBHvZZsP+fU/u+H18Pu6nqoSK16b2Y/Wxfa9f5UzYsKPN1O765P2QvgoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcoSV5pv9v//XlZrztOI87jiPrvN47Dya/8//97qjfl91nhphf++8bku9ruI8yffyniXyPdrOa9oBn9dyft4KuSbvM+XfHjrfy6+r3mdF3MMN+Tr1ud59dLX3C/xMde3y72+ra3/ofXaE3Tyb1fyfF/E38vo7zmuavvvsOj/bDfmbs3t3vq47X9djFGvvM7y/DXnNKFtUlT0qyh5n163ZXC/z3nsqu0XZQL52XX27G/TaUeXlt02c+9Pu6476G1knH+v3FHIdVV+dbqt2EnqfqpzDOGtbEfaJvM6My3VUW/PqoL+P0B+endr+ew16f60u6X/fUv1LK0YfFqdO6WVY1/qnjrJBJ2Y/GdgvaNcQ2pY1W3nl65VBVF/ofW6sPmJUWzEs17HKxbQ9aK8LK8Oha4zoO0aNVyPfy6CvGWh/qu6PHAsjxpVa1PijlYtXj73+qBWzDkfW0bj9sFaXvf5EjoGHo+4xii+kKGxkQW+qwnjgPL7oPO6q5w31sqp6jdcRhCENd6Q3AId78qadz5F/t6rd9KYySFhhrKjXrKnv76qC3Aow7p76XVu930P13vfU9R5q9yD8n6kq7Y769lD9/Ufy9QHX7f3NkfpM7/U3NBsdRthoU31+02db+Z6dkMqs33tVdYoeFU1c6WXzRd/fBtm5E1If7ml2eqy+vqPs0dI6gh313t5nV7R7kZ3Txoiy9a4hSFyElleIbSLvT9WTI3WNh1odWXd+dxghxhrqOrqqfnmfWVXvK99rO6Ax+/9G53BEZxLnOrMs18C2plHX6nEnwk5eXWipNtSNeH9/XdL7jq6yxUZEOcWpU0H900fe4ON8TluVZVj5dDwbKnv5r2VdXcP2iIFrT9lJfs6f1TXIx1LIn93zBmtVBzoj+ohRbcWkXMctF9P2sKn1XxsxrzGs7xg1XsV5L53bmlARmuDzJjv+9hd3LPSzo03QDyNeU9c+u3ctqkw2IiZscepSrH7Y+fsdVee96+yqOrYZ0OYnK26UittUSmtV+9WGmoX42Y+aGWhs+2Zl66owDpzHoixUVcAr8nNCDHA35kDwSH27HDFbjbKBd21NXyP1vCTymo+cr5e02cW6qlgbuvp1fr6RpDA15b0T0mnqs46m3nGrazwaVTbO75Zj1Ic9VfF3VRl2/bYMujbnZ4u+MjlQg3GYV+Qj1Sir6uvmuHU5xv15HcaSz4tYiVlmqwFeoHXVWch6HFT/2nHsPs51ZlmuCTmzk7LRjvrsHW2iElWOiwFtfFO9h7TzYsi1mtSpbX9bURMc+TkHztfbQW1JeYDvq9et6yJB3as3mYqaEXvCZsnX10T1UytqYKmrr3fFhBmjXJK0h67qP/bH8QAYjFdxbbAR4hjY8Ld91S+PHAtDxuSqV97y+ygbOL9bCuh796RQD/m7VOqS8/4H6u83fB6gDe0ejyIEeyjnUiqvFfV8P6ghp1gpdlVnU1WFp4uWlRDRUlOiqzuiowgVNqPuQ33OjnK5rflfq95zVc2id3wdqfC79ca02X2fSp4oqkI2VGPcCBlIuzHKuqNsdmanEDdmSz1WRgnQFOt6y9/gk5aZ/DvVaS2rzngvj9eZVrmOYaM1NeCvJHyPjnqPtYB2mFqdUiJ8SQmkTfWeQa/b8jw4vs9YV9e3EbFUWVev2Q/oa8L+pqH+5r42M546ccplDJopt6ncEDIW+j0rQvP+3TUpE+3vVrKqS+p9VlSfshtyj/I6aqr/mYq46Wqup6x5pp69DmFfPd+JEF37I7xOsrNojqHuQ8WdT+C0fR1mV+tU06SlZiy1KbS73qwzjZmO5uqsRNhcLrc8CGuIGdDNop6rundfdVaNHF5nauU6Bp2QumAqPmT7aAS0u1TqlBIY3uw8apKxre5n3ee1aUXF6Gn97Q2Dy/pI6xsO1YBRFTlhRLkkpabaVKLBsQA8G9E/erEziScFYnCZLO265L1PlNdn11ScpS1uvIa4o7nRsqIXrOx5WNSgEFZ4d9VrD2MIkwdjXJPngTkc8TrvM+q+7w9S7mjWfB6pSXltPFfofkrvV48oG71sD8M8PBlwqATIXgaeIu8+bufpOtMu14TX4MWEHabwdg+0wS+TOqX6p27AZ/gH9LbmvTnz2sQQwh0lBNZj2k72c54He5KTgTTKZRzRtKVstZknMZfFWKiV94qqR/u+vsDErvdEP54rq7rkeZe7IyYKLSWgjPqxL6RUgTrOB6+pwfRIBQFtR0Rc3wmIeu/E2G2yqYTBWkBHLj0VK57A0JakmiMu/7bWGSWlLqKDVXWPyqboL5XJXUiygsqZ+rHzdVPZrZNCeWyrBr0eJ5rdYJAJmrl7uwTq2n2O+zlewGTbX4b+slUxDIfKK1Ydx34j7k+ogacm+jECcma4m8aSjIohC+rcq0HXNcKLYnSdkyrXMcTVnubtGJe2NogeZlin2mL0jkRZTkeqnO6pMorjQV5VfycnlPdUv9GMM4FTu0a73uflaLAeKpcQTNvDmmcr0V/qNhIRpuNVxu0haizUBblnw33Rj+tbG9H+v6jqi6zvywH1PpW6pE1cH8Z4+UN1rzWTPigtz42+1txSFyJFzkGI2qoq1ak/gmarcnC25UMO/sqwywGVKmhpqhHTI1OZZmtW682r3kxMiZytFN56VynvzZQ9DHcCHpVRtpQR8XJnmPYIinmwtfI+UI1zOWBADvK2pTUbjbo/L/5jSRtkN1WZZTkLroRcV1S9Mr3OzMo1IUdaXfCC/ZfGDAwdNYvMqk6N8vC0RD/WZDvm30k7LCoxJvtT6aF7FDI79w92SWfzecGoPWg2Xkm4shB3vMqSuGOhV1/PUieMWN3wt/+66KesqBS5Ln0h5YYqjbisbateUQOsXy3GjT5vasLlI6U+d4QvclrfNSX6Lt2PlLo+zFmjFMK3jum5wVXD21MVeayZgZp5rimREGuHScz3XU74p3LL8J+1gTaIZa0z8bYaPgiYxXnrr12ts9K3B+9mfX+q/m6pZQFvd8zimF6jqjcr9M9ok9o97nVmXK5J2FAz+Yoq0xVVJzZSeO8gO2dRp6oi3tbg+6If99c1aeOyXcvdlaK/82pg94y2jNDLl6I8g5Jn2r21c9I/htV/kUJ7WFMieU8E7C4awf6UY81ij4XaklTbJ+S8eM+VoDFRt6e2W8rb3duecl36YtC4OTHPjc9QHWUseaONMTwHz6TqVo8N0Y+cbgS89kw96rukYrq8xJixQp63Ko5XQIRVADXD8HbN3EuhHA5FP0ivPoEG6LkM60GePdlBjNhm7pV1U7PDToAA8GYIR9rjQP1sooGSasnPE47jllldEwx5us6xyjUhbVUXvPQS8hrWUyrbgXaYRZ3SkhHG6ey9TvvPSScyqn/cVX3gSoBHqua7t82svVLjlkvaY5LoB+xvieIRdyz0PCsNX3mv+H4/ylarAX1FanVJCwO5E7dfNPXansu4QNIOEGtGFJAerDtyl5RPFOkzt8T3GWOXi5fRsTWiYrVTtNmaNqt+mGVha0GUd1N4r64Idnd6ZSu33Fv6Q5vVT7TD1mZC45bZPV+dzMV1jlGunngI+7zbBoPZfhplqyZasp12tM4yizp1z9cvTYKg/tbrKxcD7i3pckKa5RpVLmnX/y3RT6CYF29V2mPhirKhFVDe3bj1WPPsVjOsS/Jv6lETB0NHxUTFjbdVsZOi+u6EzCC9DthbO4zVSNRrxvVueFkVQ+Nb1LJAVURsF9eopmyzbWWzOxNodGe7dFJ4r4cBHoOopIxpCNUkA2Z13Hqu7CUb8e64AeUZXWeScn0cJgxUO5Hl2oq5FGMy04saQL1srxtZ1Sk1yVlX3qfmBKviQPnqywghdepBwvaSZrlGlUsWePl07okCEzQWaktShxFtuBInPlAbC9sp1aVagOD1JixRcXre7+6b2igVcSON5TeYMo631SvNzrqlCqgWUngr6rFvWOFlQ5RrjENZPuWgEKUu1f1tqM7lSBdJ8r2UG3RHVYwtXfD470MTQfspNoStMFGYARvKlg0VUF4ds6zPBrRRSRl1r1dWS1OqflR9HfOmr7FGUdH+tudWdh7HatZ6GHHUxKSvc+xy9W11rgcMZpW4nVbUxCZiwDzri1QbPFb1ZyNgV2WSOvVFXx+xoo5T8Xb5rWZUB716U/EJV//23VEe7MMkXqlxyjVuuWQoClrK6zGJvjBr/GPhRyPK+0GIt2eobgl3SbarlWPiuqTlb+pqfbrnSZZlseLvU1R78rIX7ybZzZxWQPFHqtPzzvyoin7q56AGLj0cQcGH2zHW7h+ogaAuhl2L3u90t12sjlMGTqnOf1Ndn3fWhnew2FrUe6pt3V6MyJEKcNY746B7kwW+o73W+6zdDGIY1rTZ0Tgdqx1y/5Z6lgGZi6KfLn9Fuz/dC9ONWS76dto4OYn2lR39KcHD6tyy7ziE0PvTtmDq9aOuntdiNsADLRBPaIPRfsTf10OuqxUUWJnkOjMsVz1FhN4mvGsxGcy8lA+1GF7ZP/ns3FHt975vsjVOnVoPyDNzqO4rS4+NtzV+T6Xd0M+F03cXfhThkfJvd6/5jukYVd+SlmvcconCqD2ECPUVEX+nbNzx6sh3bwNtKAP8Y6G3JBUW0+lt214Rvg0mAfb0zrrrJKlLavzf8dWLjYCM2jIg/pkaC49Vf+XVcfna1aSCN608N2sqj4Y3C9oXwaeW9nZTRbxVx/e6TkgBLQcNjtrvRERD2Qiq1Or13s6DmtZZ3/dVmMhrE+6up5omVLZFyKnP8pwVNfPxxOD9CLff0KDss0HodXkzFs82IUT+fZjdwiq6ajxrvvvrKnv4T06Oem8pjqtK/bfUNUYNbN6sshuzzrXj3p8SW19SZTuyfP3eM3kIqOae7caMLYi69m4K15lluXrLvktaJvBRNmuK/mnIQ4OJ6tC7YdcuBzctmFeI0ad0G9cpJQ4t3WsxZp6sUW0vaCLVUveoDxz+a7gfQzRsiH4a/VH1oZu0XBOUy7jtYTmifXRVX1gZUe5xx6umGC8HVFSdjzUWqv5xNcakcVl5eyoqEH1ZOxlcRLRL07rUFv1cW/dFxDKltqOzromazphtCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAi/P8CDABZkBDVkO7/QwAAAABJRU5ErkJggg==\n',
                            width: 80,
                            margin: [210, 0, 0, 0]
                        },
                        {text: '1. Registro de admisión', style: 'header'},
                        {
                            style: 'tableExample',
                            table: {
                                headerRows: 1,
                                keepWithHeaderRows: 1,
                                body: [
                                    [
                                        {
                                            text: 'Datos personales',
                                            style: 'header',
                                            colSpan: 6,
                                            alignment: 'center'
                                        },
                                        {},
                                        {},
                                        {},
                                        {},
                                        {}
                                    ],
                                    [
                                        {
                                            fillColor: '#EBA394',
                                            text: 'No. Historia clínica'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Apellido paterno'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Apellido materno'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Primer nombre'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Segundo nombre'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'No. Cédula ciudadanía'
                                        }
                                    ],
                                    [
                                        this.$store.state.patient.identification,
                                        this.$store.state.patient.firstLastName,
                                        this.$store.state.patient.secondLastName,
                                        this.$store.state.patient.firstName,
                                        this.$store.state.patient.secondName,
                                        this.$store.state.patient.identification
                                    ],
                                    [
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Dirección de residencia habitual'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Barrio'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Parroquia'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Cantón'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Provincia'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Zona'
                                        }
                                    ],
                                    [
                                        this.$store.state.patient.address,
                                        this.$store.state.patient.addressDetail1,
                                        this.$store.state.patient.addressDetail2,
                                        this.$store.state.patient.addressDetail3,
                                        this.$store.state.patient.state,
                                        this.$store.state.patient.zone
                                    ],
                                    [
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Teléfono'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Fecha nacimiento'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Lugar nacimiento'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Nacionalidad'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Grupo cultural'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Edad'
                                        }
                                    ],
                                    [
                                        this.$store.state.patient.phone,
                                        this.$store.state.patient.birthday,
                                        this.$store.state.patient.birthdayPlace,
                                        this.$store.state.patient.nationality,
                                        this.$store.state.patient.culturalGroup,
                                        this.$store.state.patient.age
                                    ],
                                    [
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Sexo'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Estado civil'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Profesión'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Fecha admisión'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Ocupación'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Empresa donde trabaja'
                                        }
                                    ],
                                    [
                                        this.$store.state.patient.gender,
                                        this.$store.state.patient.civilStatus,
                                        this.$store.state.patient.profession,
                                        this.$store.state.patient.admitionDate,
                                        this.$store.state.patient.ocupacion,
                                        this.$store.state.patient.company.name
                                    ],
                                    [
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Sucursal/Agencia/Planta'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Puesto de trabajo'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'En caso necesario llamar a'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Parentesco/Afinidad'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Dirección'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Teléfono'
                                        }
                                    ],
                                    [
                                        this.$store.state.patient.agencyCompany,
                                        this.$store.state.patient.jobCompany,
                                        this.$store.state.patient.emergencyCallName,
                                        this.$store.state.patient.emergencyRelationship,
                                        this.$store.state.patient.emergencyAddress,
                                        this.$store.state.patient.emergencyPhone
                                    ],
                                    [
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Tipo de sangre'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Escolaridad'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Religión'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Lateralidad'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Orientación sexual'
                                        },
                                        {
                                            fillColor: '#EBA394',
                                            text: 'Discapacidad'
                                        }
                                    ],
                                    [
                                        this.$store.state.patient.bloodType,
                                        this.$store.state.patient.studies,
                                        this.$store.state.patient.religion,
                                        this.$store.state.patient.laterality,
                                        this.$store.state.patient.sexualOrientation,
                                        this.$store.state.patient.disability
                                    ]
                                ]
                            }
                        }
                    ],
                    styles: {
                        header: {
                            fontSize: 18,
                            bold: true
                        },
                        subheader: {
                            fontSize: 15,
                            bold: true
                        },
                        quote: {
                            italics: true
                        },
                        tableExample: {
                            margin: [0, 5, 0, 15],
                            fontSize: 8

                        },
                        tableHeader: {
                            margin: [40, 30, 0, 15],
                            fontSize: 8

                        },
                        tableHeaderFooter: {
                            margin: [40, 0, 0, 15],
                            fontSize: 8

                        },
                        tableLittle: {
                            margin: [0, 0, 0, 15],
                            fontSize: 6

                        },
                    },
                    pageMargins: [ 40, 60, 40, 60 ]
                }
                var win = window.open('', '_blank');
                pdfMake.createPdf(docDefinition).open({}, win);
            },
            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (true) {
                    // Para Safari
                    if (!(dateReg instanceof Date)) {
                        var b = dateReg.toString().split(/\D/);
                        date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                    } else {
                        date = new Date(dateReg);
                    }
                } else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                var str = date.getFullYear() + "-" + month + "-" + day;
                return str;
            },
            getFormattedHour(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (true) {
                    // Para Safari
                    if (!(dateReg instanceof Date)) {
                        var b = dateReg.toString().split(/\D/);
                        date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                    } else {
                        date = new Date(dateReg);
                    }
                } else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = hour + ":" + min + ":" + sec;
                return str;
            },
        },
        computed: {
            disableNoconoceFIT() {                
                let fecIsEmpty = false;                
                if (!this.$store.state.patient.emergencyRelationshipPhone.it.fec) {
                    fecIsEmpty = true;
                }
                if (!fecIsEmpty) {
                    this.$store.state.patient.emergencyRelationshipPhone.it.noc = false
                }                
                return !fecIsEmpty
            },
            disableNoconoceFR() {                
                let fecIsEmpty = false;
                if (!this.$store.state.patient.emergencyRelationshipPhone.reint.fec) {
                    fecIsEmpty = true;
                }
                if (!fecIsEmpty) {
                    this.$store.state.patient.emergencyRelationshipPhone.reint.noc = false
                }                
                return !fecIsEmpty
            },
            disableNoconoceFUL() {                
                let fecIsEmpty = false;
                if (!this.$store.state.patient.emergencyRelationshipPhone.udl.fec) {
                    fecIsEmpty = true;
                }
                if (!fecIsEmpty) {
                    this.$store.state.patient.emergencyRelationshipPhone.udl.noc = false
                }                
                return !fecIsEmpty
            },
        },
        created() {
            this.e1 = 1            
            // Initialize emergencyRelationshipPhone if not present or if it's a string
            if (!this.$store.state.patient.emergencyRelationshipPhone || typeof this.$store.state.patient.emergencyRelationshipPhone === 'string') {
                if (typeof this.$store.state.patient.emergencyRelationshipPhone === 'string' && this.$store.state.patient.emergencyRelationshipPhone !== '') {
                    try {
                        this.$store.state.patient.emergencyRelationshipPhone = JSON.parse(this.$store.state.patient.emergencyRelationshipPhone)
                    } catch (e) {
                        this.$store.state.patient.emergencyRelationshipPhone = {
                            ap: '',
                            it: { fec: '', noc: false },
                            reint: { fec: '', noc: false },
                            udl: { fec: '', noc: false },
                            at: false
                        }
                    }
                } else {
                    this.$store.state.patient.emergencyRelationshipPhone = {
                        ap: '',
                        it: { fec: '', noc: false },
                        reint: { fec: '', noc: false },
                        udl: { fec: '', noc: false },
                        at: false
                    }
                }
            }

            let anamnesisExamenFisico=0
            this.$store.dispatch('getPatientAnamnesisByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                if (this.$store.state.anamnesisList.length > 0) {
                    anamnesisExamenFisico++;
                }
                this.$store.dispatch('getPatientJobAndHealthByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                    if (this.$store.state.workAndHealthList.length > 0) {
                        anamnesisExamenFisico++
                    }
                    if(anamnesisExamenFisico==2){
                        this.e1 = 2;
                    }
                    if(this.$store.state.routeSheet.status=="false"){
                        this.e1 = 3;
                    }
                    this.itemsJobCompany = []
                    this.itemsAgencyCompany = []
                    this.$store.dispatch('getCompanyJobsByCompany', this.$store.state.patient.company.id).then(
                        response => {
                            for (let i = 0; i < this.$store.state.companyJobs.length; i++) {
                                this.itemsJobCompany.push(this.$store.state.companyJobs[i])
                            }
                        },
                        error => {
                            this.$store.state.dialogError = true;
                        }
                    )
                    this.$store.dispatch('getCompanyAgenciesByCompany', this.$store.state.patient.company.id).then(
                        response => {
                            for (let i = 0; i < this.$store.state.companyAgencies.length; i++) {
                                this.itemsAgencyCompany.push(this.$store.state.companyAgencies[i])
                            }
                        },
                        error => {
                            this.$store.state.dialogError = true;
                        }
                    )
                    this.$store.dispatch('getPatientAnamnesisByRouteSheets', this.$store.state.routeSheet.id).then(response => {
                        if(this.$store.state.anamnesisList.length>0){
                            for (let i = 0; i < 1; i++) {
                                let anam = JSON.parse(this.$store.state.anamnesisList[i].value)
                                anam.id = this.$store.state.anamnesisList[i].id
                                if (anam) {
                                    if (anam.antecedentesPersonales[25]) {
                                        this.$store.state.patient.laterality = anam.antecedentesPersonales[25].descripcion;
                                    }
                                    if (anam.antecedentesPersonales[26]) {
                                        this.$store.state.patient.disability = anam.antecedentesPersonales[26].descripcion;
                                    }
                                }
                            }
                        }
                    }, error => {
                        this.$store.state.progress = false;
                        this.$store.state.dialogError = true;
                    })


                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            }, error => {
                this.$store.state.progress = false;
                this.$store.state.dialogError = true;
            })


        },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patient/patientData/PatientData.vue